<template>
  <div
    v-if="
      currentMission != null &&
      currentMission.typeName === 'ConstellationSimulationRequest'
    "
  >
    <div class="text-xs-center" v-if="displayComputationWidget">
      <exo-mission-computation></exo-mission-computation>
    </div>
    <div v-if="displayResult" m-0 p-0>
      <v-card elevation="0">
        <v-row align="center" justify="center">
          <v-col cols="7">
            <span class="ml-4 headline grey--text">{{
              currentMission.name.toUpperCase()
            }}</span>
          </v-col>
          <v-spacer></v-spacer>
          <div
            v-if="
              currentResultsLog &&
              currentResultsLog.errors &&
              currentResultsLog.errors.length
            "
            class="justify-center"
          >
            <v-dialog v-model="dialog" width="700">
              <template v-slot:activator="{ on: dialog }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on: tooltip }">
                    <v-btn
                      icon
                      class="mr-5 bug-button"
                      v-on="{ ...tooltip, ...dialog }"
                    >
                      <icon
                        class="white--text"
                        scale="1.5"
                        name="user-injured"
                      />
                    </v-btn>
                  </template>
                  <span>Bug report</span>
                </v-tooltip>
              </template>
              <error-log-display
                :root="_self"
                :computationLog="currentResultsLog"
              ></error-log-display>
            </v-dialog>
          </div>
          <v-menu
            transition="slide-y-transition"
            nudge-bottom="15"
            offset-y
            bottom
            min-width="600"
            max-height="600"
            v-if="dataLoaded"
          >
            <template v-slot:activator="{ on }">
              <v-btn class="mr-10" color="primary" dark v-on="on">
                Export
                <v-icon dark>arrow_drop_down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                @click.stop="exportSpacecraftVisibilityFromGroundStation()"
              >
                <v-list-item-title :color="$vuetify.theme.dark ? '' : 'black'"
                  >Spacecraft visibility from ground stations</v-list-item-title
                >
              </v-list-item>
              <v-list-item
                @click.stop="exportGroundStationVisibilityFromPayload()"
              >
                <v-list-item-title :color="$vuetify.theme.dark ? '' : 'black'"
                  >Ground stations visibility from spacecraft
                  payload</v-list-item-title
                >
              </v-list-item>
              <v-list-item @click.stop="exportIPoIVisibilityFromPayload()">
                <v-list-item-title :color="$vuetify.theme.dark ? '' : 'black'"
                  >Isolated point of interest visibility from
                  payload</v-list-item-title
                >
              </v-list-item>
              <v-list-item @click.stop="exportThreeDEphemerides()">
                <v-list-item-title :color="$vuetify.theme.dark ? '' : 'black'"
                  >Spacecraft ephemerides</v-list-item-title
                >
              </v-list-item>
            </v-list>
          </v-menu>
          <v-tooltip
            bottom
            class="caption justify-center warning--text"
            v-if="currentMission.dirty"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                large
                class="white--text"
                v-on="on"
                @click.stop="requestComputation()"
                color="warning"
              >
                Start Recompute
              </v-btn>
            </template>
            <span
              >You have changed some components of the mission. This results
              does not match the current inputs. Please recompute the mission to
              update.</span
            >
          </v-tooltip>
          <!-- <v-tooltip bottom v-if="dataLoaded">
            <template v-slot:activator="{ on }">
              <v-btn
                large
                icon
                color="primary"
                class="mr-5"
                v-on="on"
                @click="settingsDialog = true"
              >
                <icon scale="1.5" class="primary--text" name="cogs" />
              </v-btn>
            </template>
            <span>Dashboard settings</span>
          </v-tooltip> -->
        </v-row>
      </v-card>
    </div>
    <v-row
      no-gutters
      v-if="
        currentResultsLog &&
        (!currentResultsLog.errors || currentResultsLog.errors.length === 0)
      "
    >
      <v-col cols="6">
        <v-row no-gutters>
          <v-col>
            <v-card class="mt-3 ml-3 mr-3 pa-2 cesium-card">
              <cesium-viewer
                style="width: 100%; height: 100%"
                ref="CesiumContainer"
              />
              <!-- <div
                class="viewer"
                style="width: 100%, heigth: 100%"
                :id="idWidget3DView"
                :key="updateIndex"
              ></div> -->
            </v-card>
          </v-col>
        </v-row>
        <v-row class="mt-3" no-gutters>
          <v-col>
            <v-card class="ml-3 mr-3 pa-2">
              <v-card-title>
                Ground Station Information
                <exo-help-dialog margin="m-0">
                  <b>Ground station visibility information</b>
                  <br />
                  The visibility characteristics related to the ground stations
                  are the following:
                  <ul>
                    <li>
                      <b>Total visibility time</b> : the cumulated duration of
                      the time intervals during which at least one spacecraft is
                      visible from the ground station.
                    </li>
                    <li>
                      <b>Number of accesses</b> : the number of distinct
                      intervals during which at least one spacecraft is visible
                      from the ground station.
                    </li>
                    <li>
                      <b>Average visibility interval duration</b> : the average
                      duration of the visibility intervals.
                    </li>
                    <li>
                      <b>Average revisit time</b> : the average duration between
                      two visibility intervals.
                    </li>
                  </ul>
                </exo-help-dialog>
              </v-card-title>
              <v-row>
                <v-col cols="6">
                  <stats-card
                    color="#2A94DE"
                    awesomeicon="eye"
                    title="Total Visibility Time"
                    cardId="totalVisibilitTime"
                    :value="
                      convertToHourFormat(
                        groundStationInformation.totalVisibilityTime
                      )
                    "
                    unit=""
                  />
                </v-col>
                <v-col cols="6">
                  <stats-card
                    color="#38AD38"
                    icon="satellite"
                    title="Number of Accesses"
                    cardId="stationNumberOfAccesses"
                    :value="groundStationInformation.stationNumberOfAccesses"
                    unit=""
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <stats-card
                    color="#F72C2C"
                    icon="timer"
                    title="Average Visibility Interval Duration"
                    cardId="averageVisibilityIntervalDuration"
                    :value="
                      this.convertToHourFormat(
                        groundStationInformation.averageIntervalTime
                      )
                    "
                    unit=""
                  />
                </v-col>
                <v-col cols="6">
                  <stats-card
                    color="#FF7E0D"
                    icon="timer"
                    title="Average revisit time"
                    cardId="averageStationRevisitTime"
                    :value="
                      this.convertToHourFormat(
                        groundStationInformation.averageStationRevisitTime
                      )
                    "
                    unit=""
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-select
                    class="ml-2 mr-2"
                    :items="availableGroundStations"
                    :label="timelineGroundStationCategory"
                    v-on:input="displayGroundStationTimeline"
                    v-model="currentGroundStationLabel"
                    v-if="currentGroundStationLabel != null"
                    :menu-props="{ transition: 'scale-transition' }"
                  >
                  </v-select>
                  <v-row> </v-row>
                  <v-select
                    class="ml-2 mr-2"
                    :items="availableConstellations"
                    :label="timelineConstellationCategory"
                    v-on:input="displayGroundStationTimeline"
                    v-model="currentConstellationLabel"
                    v-if="currentConstellationLabel != null"
                    :menu-props="{ transition: 'scale-transition' }"
                  >
                    <template v-slot:item="{ item }">
                      {{ item.replaceAll('/', '') }}
                    </template>
                    <template v-slot:selection="{ item }">
                      {{ item.replaceAll('/', '') }}
                    </template>
                  </v-select>
                </v-col>
                <v-col>
                  <v-select
                    class="ml-2 mr-2"
                    :items="availableConstellationPlanes"
                    :label="timelinePlaneCategory"
                    v-on:input="drawGroundStationTimeline"
                    v-model="currentPlaneLabel"
                    v-if="currentPlaneLabel != null"
                    :menu-props="{ transition: 'scale-transition' }"
                  >
                    <template v-slot:item="{ item }">
                      {{ item.replaceAll('/', '') }}
                    </template>
                    <template v-slot:selection="{ item }">
                      {{ item.replaceAll('/', '') }}
                    </template>
                  </v-select>
                  <v-select
                    class="ml-2 mr-2"
                    :items="availableConstellationInPlaneSpacecrafts"
                    :label="timelineSpacecraftCategory"
                    v-on:input="drawGroundStationTimeline"
                    v-model="currentInPlaneSpacecraftIndexLabel"
                    v-if="currentInPlaneSpacecraftIndexLabel != null"
                    :menu-props="{ transition: 'scale-transition' }"
                  >
                    <template v-slot:item="{ item }">
                      {{ item.replaceAll('/', '') }}
                    </template>
                    <template v-slot:selection="{ item }">
                      {{ item.replaceAll('/', '') }}
                    </template>
                  </v-select>
                </v-col>
              </v-row>
              <v-row class="ml-2">
                Spacecrafts visibility from the ground station
              </v-row>
              <v-row>
                <v-col>
                  <div class="ml-3 mr-4" id="groundStationTimeline"></div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="6">
        <v-row no-gutters>
          <v-col v-if="displayDistanceBetweenSpacecrafts">
            <v-card class="mr-3">
              <v-card-title>
                Distance between two Spacecrafts
                <exo-help-dialog
                  margin="m-0"
                  title="Distance between two spacecrafts"
                >
                  The evolution of the distance of the shortest straight line
                  between the two selected spacecrafts is displayed.
                </exo-help-dialog>
              </v-card-title>
              <v-row>
                <v-col>
                  <v-row>
                    <v-col cols="6">
                      <v-select
                        class="ml-4 mr-2"
                        :items="availableSpacecrafts"
                        :label="spacecraftCategoryOne"
                        v-on:input="drawDistanceGraph"
                        v-model="currentSpacecraftOneLabel"
                        v-if="currentSpacecraftOneLabel != null"
                        :menu-props="{ transition: 'scale-transition' }"
                      >
                        <template v-slot:selection="{ item }">
                          {{ item.replaceAll('#/#/', ' / ') }}
                        </template>
                        <template v-slot:item="{ item }">
                          {{ item.replaceAll('#/#/', ' / ') }}
                        </template>
                      </v-select>
                    </v-col>
                    <v-col cols="6">
                      <v-select
                        class="ml-4 mr-2"
                        :items="availableSpacecrafts"
                        :label="spacecraftCategoryTwo"
                        v-on:input="drawDistanceGraph"
                        v-model="currentSpacecraftTwoLabel"
                        v-if="currentSpacecraftTwoLabel != null"
                        :menu-props="{ transition: 'scale-transition' }"
                      >
                        <template v-slot:selection="{ item }">
                          {{ item.replaceAll('#/#/', ' / ') }}
                        </template>
                        <template v-slot:item="{ item }">
                          {{ item.replaceAll('#/#/', ' / ') }}
                        </template>
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-checkbox
                        class="ml-3"
                        @change="changeDistanceLineVisibility"
                        :label="distanceLineCheckboxLabel"
                        v-model="distanceLineCheckboxValue"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="mb-8">
                  <div
                    id="idDistanceSpacecrafts"
                    ref="idDistanceSpacecrafts"
                  ></div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col class="mt-3">
            <v-card class="mr-3 mb-3">
              <v-card-title>
                Satellite Information
                <exo-help-dialog margin="m-0" title="Satellite information">
                  The visibility characteristics from a satellite point of view
                  are displayed.
                  <br />
                  The first timeline shows the time intervals during which the
                  selected spacecraft is in the visibility cone of one of the
                  ground stations.
                  <br />
                  The second timeline shows the time intervals during which the
                  selected spacecraft's payload has one of the ground station
                  within its field of regard.
                </exo-help-dialog>
              </v-card-title>
              <v-row no-gutters>
                <v-col class="p-1 pr-3 m-0">
                  <v-row>
                    <v-col cols="6">
                      <v-select
                        class="ml-2 mr-2"
                        :items="availableConstellations"
                        :label="spacecraftPOVTimelineConstellationsCategory"
                        v-on:input="displaySpacecraftPOVTimeline"
                        v-model="
                          currentSpacecraftPOVTimelineConstellationsLabel
                        "
                        v-if="
                          currentSpacecraftPOVTimelineConstellationsLabel !=
                          null
                        "
                        :menu-props="{ transition: 'scale-transition' }"
                      >
                      </v-select>
                    </v-col>
                    <v-col cols="6">
                      <v-select
                        class="mr-2"
                        :items="
                          availableSpacecraftPOVTimelineConstellationPlanes
                        "
                        :label="spacecraftPOVTimelinePlanesCategory"
                        v-on:input="drawSpacecraftTimeline"
                        v-model="
                          currentSpacecraftPOVTimelineConstellationPlaneLabel
                        "
                        v-if="
                          currentSpacecraftPOVTimelineConstellationPlaneLabel !=
                          null
                        "
                        :menu-props="{ transition: 'scale-transition' }"
                      >
                        <template v-slot:item="{ item }">
                          {{ item.replaceAll('/', '') }}
                        </template>
                        <template v-slot:selection="{ item }">
                          {{ item.replaceAll('/', '') }}
                        </template>
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-select
                    class="ml-2 mr-2"
                    :items="availableSpacecraftPOVTimelineSpacecraftInPlanes"
                    :label="spacecraftPOVTimelineSpacecraftCategory"
                    v-on:input="drawSpacecraftTimeline"
                    v-model="currentSpacecraftPOVTimelineSpacecraftIndexLabel"
                    v-if="
                      currentSpacecraftPOVTimelineSpacecraftIndexLabel != null
                    "
                    :menu-props="{ transition: 'scale-transition' }"
                  >
                    <template v-slot:item="{ item }">
                      {{ item.replaceAll('/', '') }}
                    </template>
                    <template v-slot:selection="{ item }">
                      {{ item.replaceAll('/', '') }}
                    </template>
                  </v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-row class="ml-2">
                    Spacecraft visibility from ground stations
                  </v-row>
                  <v-row>
                    <v-col>
                      <div
                        id="spacecraftTimeline"
                        ref="spacecraftTimeline"
                      ></div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-row class="ml-2">
                    Ground stations visibility from spacecraft's payload
                  </v-row>
                  <v-row no-gutters>
                    <v-col>
                      <div
                        id="spacecraftPayloadTimeline"
                        ref="spacecraftPayloadTimeline"
                      ></div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col v-if="areIsolatedPointOfInterestsDefined">
                  <v-row class="ml-2">
                    Isolated points of interest visibility from spacecraft's
                    payload
                  </v-row>
                  <v-row no-gutters>
                    <v-col>
                      <div
                        id="pointOfInterestTimeline"
                        ref="pointOfInterestTimeline"
                      ></div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-col class="mb-8">
                <div id="idDataSpacecrafts" ref="idDataSpacecrafts"></div>
              </v-col>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- <v-dialog v-model="settingsDialog" width="800">
      <v-card>
        < !-- very important to disable if not displayed : the slider component would update zbound otherwize -- >
        <v-card-title class="pb-0">
          <v-row align="center">
            <icon scale="1.5" class="blue--text lighten-4" name="cogs" />
            <v-toolbar-title class="grey--text title ml-2"
              >Display settings</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-btn icon v-on:click="settingsDialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-row>
        </v-card-title>
        <v-col>
          <exo-form-alert type="info">
            For each spacecraft, the label is : Plane Index / Spacecraft Index
            in Plane
          </exo-form-alert>
          <v-row no-gutters>
            <v-col>
              <v-checkbox
                @change="changeGroundStationVisibility"
                :label="groundStationCheckboxLabel"
                v-model="groundStationCheckboxValue"
              ></v-checkbox>
              <v-checkbox
                @change="changePayloadConesVisibility"
                :label="payloadConesLabel"
                v-model="payloadConesValue"
              ></v-checkbox>
            </v-col>
            <v-col>
              <v-checkbox
                @change="changeConstellationPlanesColor"
                :label="planesColorLabel"
                v-model="planesColorValue"
              ></v-checkbox>
              <v-checkbox
                @change="changeGroundStationConesVisibility"
                :label="groundStationConesCheckboxLabel"
                v-model="groundStationConesCheckboxValue"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-select
            :items="availableConstellations"
            :label="cesiumConstellationSelectionCategory"
            :multiple="true"
            v-on:input="changeConstellationsVisibility"
            v-model="currentCesiumConstellationsLabel"
            v-if="currentCesiumConstellationsLabel != null"
            :menu-props="{ transition: 'scale-transition' }"
          >
          </v-select>
          <v-select
            :items="availableCesiumConstellationPlane"
            :label="cesiumConstellationPlaneCategory"
            :multiple="true"
            v-on:input="changeConstellationsPlanesVisibility"
            v-model="currentCesiumConstellationPlanesLabel"
            v-if="
              currentCesiumConstellationPlanesLabel != null &&
              isPlaneSelectionAvailable
            "
            :menu-props="{ transition: 'scale-transition' }"
          >
          </v-select>
        </v-col>
      </v-card>
    </v-dialog> -->
  </div>
</template>
<script>
import NumericalConstellationViewer from './NumericalConstellationViewer.vue'
import dashboardComponents from '../../components/Dashboard/index.js'
import CesiumTools from '../../components/ThreeD/CesiumTools'
import dataTools from '../../tools/data.js'
import dashboardTools from '../../tools/dashboard.js'
import { mapGetters } from 'vuex'
import Vue from 'vue'
import errorMixin from '../../mixins/logHandler.js'
import constellationUtils from '../../mixins/constellationUtils'
import Plotly from 'plotly.js-dist'
import * as Cesium from 'cesium'
import * as d3 from 'd3'
import 'cesium/Widgets/widgets.css'
import moment from 'moment'

Vue.use(dashboardComponents)

export default {
  name: 'ConstellationDashboard',
  mixins: [errorMixin, constellationUtils],
  components: {
    'cesium-viewer': NumericalConstellationViewer
  },

  watch: {
    updateIndex(val) {
      if (this.dataLoaded) {
        Vue.nextTick(() => {
          this.prepareAndDisplayData()
        })
      }
    },
    minZInConfiguration() {
      Vue.set(this.editedDashboardConfiguration, 'zBounds', [
        this.minZInConfiguration,
        this.maxZInConfiguration
      ])
      // not refreshing correctly this.editedDashboardConfiguration.zBounds[0] = this.minZInConfiguration
    },
    maxZInConfiguration() {
      Vue.set(this.editedDashboardConfiguration, 'zBounds', [
        this.minZInConfiguration,
        this.maxZInConfiguration
      ])
      // not refreshing correctly this.editedDashboardConfiguration.zBounds[1] = this.maxZInConfiguration
    }
  },

  computed: {
    ...mapGetters({
      userSettings: 'userSettings',
      currentMission: 'currentMission',
      currentResultsLog: 'currentResultsLog',
      defaultUserSettings: 'defaultUserSettings',
      localDefaultUserSettings: 'localDefaultUserSettings'
    }),

    displayComputationWidget() {
      return dashboardTools.displayComputationWidget(this)
    },
    displayResult() {
      return dashboardTools.displayResult(this)
    },
    displayError() {
      return dashboardTools.displayError(this)
    },
    computationNeeded() {
      dashboardTools.computationNeeded(this)
    },
    areIsolatedPointOfInterestsDefined() {
      const isolatedPts =
        this.currentResultsLog.results.isolatedPointsOfInterest
      return isolatedPts != null && isolatedPts.length > 0
    },
    displayDistanceBetweenSpacecrafts() {
      return false
      // not working since cesium upgrade in 2022, to be fixed. this.currentResultsLog?.results?.displayDistanceBetweenSpacecraft
    },
    dataLoaded() {
      return dashboardTools.dataLoaded(this)
    },

    resultLoaded() {
      return (
        this.currentMission &&
        this.currentResultsLog?.results != null &&
        this.currentResultsLog.errors != null
      )
    },

    startOfSimulationDate() {
      if (this.currentMission?.simulationDate) {
        return moment
          .utc(this.currentResultsLog.results.missionStartDate)
          .toDate()
      } else {
        return moment.utc().toDate()
      }
    },

    endOfSimulationDate() {
      if (this.currentMission?.simulationDuration) {
        return this.computeDateFromDuration(
          this.currentMission.simulationDuration
        )
      } else {
        return moment.utc().toDate()
      }
    },
    isPlaneSelectionAvailable() {
      if (this.currentCesiumConstellationsLabel != null) {
        return this.currentCesiumConstellationsLabel.length === 1
      }
    }
  },

  data() {
    return {
      dialog: false,

      editedDashboardConfiguration: {
        zBounds: [-1, 1],
        fullWidth3DView: false,
        display3DView: true,
        displayMapView: true,
        displayHeatmapView: true,
        interpolate: false,
        displayGroundTrack: false,
        numberOfOrbits: 0,
        currentCategory: 'stationNumberOfAccesses',
        currentMap: 'stationNumberOfAccesses',
        currentColorMap: 'Jet'
        // TODO flat/globe + position
      },
      appliedDashboardConfiguration: {
        zBounds: [-1, 1],
        fullWidth3DView: false,
        display3DView: true,
        displayMapView: true,
        displayHeatmapView: true,
        interpolate: false,
        displayGroundTrack: false,
        numberOfOrbits: 0,
        currentCategory: 'stationNumberOfAccesses',
        currentMap: 'stationNumberOfAccesses',
        currentColorMap: 'Jet'
        // TODO flat/globe + position
      },

      ID_SEPARATOR: '#/#',
      currentTimelineLabel: null,
      currentGroundStationLabel: null,
      currentSpacecraftOneLabel: null,
      currentSpacecraftTwoLabel: null,
      currentConstellationLabel: null,
      currentPlaneLabel: null,
      currentInPlaneSpacecraftIndexLabel: null,
      currentSpacecraftTimelineLabel: null,
      currentSpacecraftPayloadTimelineLabel: null,
      currentCesiumConstellationsLabel: null,
      currentCesiumConstellationPlanesLabel: null,
      currentSpacecraftPOVTimelineConstellationsLabel: null,
      currentSpacecraftPOVTimelineConstellationPlaneLabel: null,
      currentSpacecraftPOVTimelineSpacecraftIndexLabel: null,
      numberOfSpacecraft: 0,

      groundStationCheckboxLabel: ' Ground Stations ',
      groundStationCheckboxValue: true,
      distanceLineCheckboxLabel: ' Show Distance Line on the 3D view',
      distanceLineCheckboxValue: false,
      planesColorLabel: ' Display different colors for each plane ',
      planesColorValue: false,
      payloadConesLabel: ' Display Payload Cones Visibility',
      payloadConesValue: false,

      groundStationConesCheckboxLabel: ' Ground Stations Cones Visibility ',
      groundStationConesCheckboxValue: false,
      timelineCategory: '',
      timelineConstellationCategory: '',
      timelineGroundStationCategory: '',
      timelineSpacecraftCategory: '',
      timelinePlaneCategory: '',
      spacecraftCategoryOne: '',
      spacecraftCategoryTwo: '',
      spacecraftTimelineCategory: '',
      cesiumConstellationSelectionCategory: '',
      cesiumConstellationPlaneCategory: '',
      spacecraftPOVTimelinePlanesCategory: '',
      spacecraftPOVTimelineConstellationsCategory: '',
      spacecraftPOVTimelineSpacecraftCategory: '',
      availableTimelines: [],
      availableConstellations: [],
      availableGroundStations: [],
      availableSpacecrafts: [],
      availableConstellationPlanes: [],
      availableConstellationInPlaneSpacecrafts: [],
      availableCesiumConstellations: [],
      availableCesiumConstellationPlane: [],
      availableSpacecraftPOVTimelineConstellationPlanes: [],
      availableSpacecraftPOVTimelineSpacecraftInPlanes: [],
      timelineIntervals: {},
      idWidget3DView: 'CesiumContainer',
      buildingMap: false,
      terrainProvider: null,
      viewer: null,
      data: [],
      factorX: 16,
      factorY: 16,
      mapboxToken:
        'pk.eyJ1IjoiZXhvdHJhaWwiLCJhIjoiY2szcTNnZmFkMDkzbzNtcDhzMm0ydmJ5YyJ9.5so1MY_ou6yoPmLAzLchUg',
      bounds: null,
      label: null,
      groundStationInformation: {},
      updateIndex: 0,
      currentData: null,
      emptyResult: false,
      ellipsoid: null,
      cartesianDataMulti: [[]],
      cartesianDataMultiMap: null,
      cartesianGroundProjectionDataMultiMap: null,
      groundStationsCones: [],
      czml: [],
      czmlLine: [],
      czmlDataSource: null,
      constellationColors: [
        [23, 190, 207, 255],
        [255, 127, 14, 255],
        [44, 160, 44, 255],
        [214, 39, 40, 255],
        [148, 103, 189, 255],
        [140, 86, 75, 255],
        [227, 119, 194, 255],
        [127, 127, 127, 255],
        [188, 189, 34, 255],
        [23, 190, 207, 255]
      ],
      constellationColorsMap: null,
      scaleX: null,
      scaleXSpacecraftFromGround: null,
      scaleXGroundFromSpacecraft: null,
      scaleXPoIFromSpacecraft: null,
      settingsDialog: false
    }
  },
  mounted() {
    let earthRadiusEGM96 = 6378136.3
    this.ellipsoid = new Cesium.Ellipsoid(
      earthRadiusEGM96,
      earthRadiusEGM96,
      earthRadiusEGM96
    )
    this.$root.$on('current-results-updated', this.currentResultsUpdatedHandler)
    setTimeout(() => {
      this.loadLayout()
    }, 1)
    this.updateTimelineCursors()
  },

  beforeDestroy() {
    // When switching page, purge plotly context to avoid memory leaks and errors when resizing page
    // No catch if the plot didn't rendered
    this.currentData = null
    this.emptyResult = false
    this.clean3DView()

    this.cleanTimelines()
    this.$root.$off(
      'current-results-updated',
      this.currentResultsUpdatedHandler
    )
  },

  methods: {
    currentResultsUpdatedHandler() {
      setTimeout(() => {
        this.loadLayout()
      }, 1)
    },

    async copyTextToClipboard(text) {
      await navigator.clipboard.writeText(text)
      this.displayMessage(
        'Text copied to clipboard',
        '',
        'notification',
        'success'
      )
    },

    exportThreeDEphemerides() {
      let dataToExport = ''
      dataToExport +=
        'Constellation name' +
        ',' +
        'Plane index' +
        ',' +
        'Spacecraft index' +
        ',' +
        'Simulation duration' +
        ',' +
        'X coordinate' +
        ',' +
        'Y coordinate' +
        ',' +
        'Z coordinate' +
        '\n'
      Object.entries(this.currentResultsLog.results.threedEphemerides).forEach(
        (entry) => {
          const [key, value] = entry
          const nbOfEphemerides = Math.floor(value.length / 4)
          for (let index = 0; index < nbOfEphemerides; index++) {
            dataToExport += this.splitKeyName(key) + ',' + value[index] + '\n'
          }
        }
      )

      dataTools.downloadFile(
        this.currentMission.name + '_sc_ephemerides',
        dataToExport
      )
    },

    splitKeyName(key) {
      const splittedKey = key.split('#/#')
      const constellationName = splittedKey[0]
      const planeNumber =
        splittedKey[1].split('-').length === 2
          ? splittedKey[1].split('-')[1]
          : splittedKey[1].split('-')[0]
      const spacecraftNumber =
        splittedKey[2].split('-').length === 2
          ? splittedKey[2].split('-')[1]
          : splittedKey[2].split('-')[0]
      if (
        splittedKey[2].split('-').length != 2 ||
        splittedKey[1].split('-').length != 2
      ) {
        return ''
      }
      return constellationName + ',' + planeNumber + ',' + spacecraftNumber
    },

    exportSpacecraftVisibilityFromGroundStation() {
      let dataToExport = ''
      dataToExport +=
        'Ground station name' +
        ',' +
        'Constellation name' +
        ',' +
        'Plane index' +
        ',' +
        'Spacecraft index' +
        ',' +
        'Start of visibility interval (s)' +
        ',' +
        'End of visibility interval (s)' +
        '\n'
      Object.entries(
        this.currentResultsLog.results.constellationsVisibilityData
      ).forEach((constellation) => {
        const [keyConstellation, valueConstellation] = constellation
        Object.entries(
          valueConstellation.groundStationsVisibilityIntervals
        ).forEach((groundStation) => {
          const [keyGroundStation, valueGroundStation] = groundStation
          Object.entries(valueGroundStation.stationVisibilityTimeline).forEach(
            (spacecraft) => {
              const [keySpacecraft, valueSpacecraft] = spacecraft
              Object.entries(valueSpacecraft).forEach((timeInterval) => {
                const [keyTimeInterval, valueTimeInterval] = timeInterval
                if (this.splitKeyName(keySpacecraft) != '') {
                  dataToExport +=
                    keyGroundStation +
                    ',' +
                    this.splitKeyName(keySpacecraft) +
                    ',' +
                    valueTimeInterval.start +
                    ',' +
                    valueTimeInterval.end +
                    ',' +
                    '\n'
                }
              })
            }
          )
        })
      })

      dataTools.downloadFile(
        this.currentMission.name + '_sc_visibility_from_gs',
        dataToExport
      )
    },

    exportGroundStationVisibilityFromPayload() {
      let dataToExport = ''
      dataToExport +=
        'Constellation name' +
        ',' +
        'Plane index' +
        ',' +
        'Spacecraft index' +
        ',' +
        'Ground station name' +
        ',' +
        'Start of visibility interval (s)' +
        ',' +
        'End of visibility interval (s)' +
        ',' +
        '\n'
      dataToExport += this.helperExportIPoIOrGroundStationFromPayload(
        'groundStationPayloadVisibilityIntervals'
      )

      dataTools.downloadFile(
        this.currentMission.name + '_gs_visibility_from_sc_payload',
        dataToExport
      )
    },

    exportIPoIVisibilityFromPayload() {
      let dataToExport = ''
      dataToExport +=
        'Constellation name' +
        ',' +
        'Plane index' +
        ',' +
        'Spacecraft index' +
        ',' +
        'Isolated point of interest' +
        ',' +
        'Start of visibility interval (s)' +
        ',' +
        'End of visibility interval (s)' +
        ',' +
        '\n'
      dataToExport += this.helperExportIPoIOrGroundStationFromPayload(
        'aoipayloadVisibilityIntervals'
      )

      dataTools.downloadFile(
        this.currentMission.name +
          '_isolatedPtOfInterest_visibility_from_sc_payload',
        dataToExport
      )
    },

    helperExportIPoIOrGroundStationFromPayload(isolatedPtOrGroundStation) {
      let dataToExport = ''
      let desiredVisibilityArea = null

      Object.entries(
        this.currentResultsLog.results.constellationsVisibilityData
      ).forEach((constellation) => {
        const [keyConstellation, valueConstellation] = constellation
        Object.entries(
          valueConstellation.spacecraftVisibilityIntervals
        ).forEach((spacecraft) => {
          const [keySpacecraft, valueSpacecraft] = spacecraft
          if (
            isolatedPtOrGroundStation ===
            'groundStationPayloadVisibilityIntervals'
          ) {
            desiredVisibilityArea =
              valueSpacecraft.groundStationPayloadVisibilityIntervals
          } else if (
            isolatedPtOrGroundStation === 'aoipayloadVisibilityIntervals'
          ) {
            desiredVisibilityArea =
              valueSpacecraft.aoipayloadVisibilityIntervals
          } else {
            return ''
          }
          Object.entries(desiredVisibilityArea).forEach(
            (groundStationOrIsolatedPtOfInterest) => {
              const [keyGS, valueGS] = groundStationOrIsolatedPtOfInterest
              Object.entries(valueGS).forEach((timeInterval) => {
                const [keyTimeInterval, valueTimeInterval] = timeInterval
                dataToExport +=
                  this.splitKeyName(keySpacecraft) +
                  ',' +
                  keyGS +
                  ',' +
                  valueTimeInterval.start +
                  ',' +
                  valueTimeInterval.end +
                  ',' +
                  '\n'
              })
            }
          )
        })
      })
      return dataToExport
    },

    croppedLabels(labels) {
      if (labels != null) {
        let croppedLabels = []
        for (let i = 0; i < labels.length; i++) {
          if (labels[i].length > 12) {
            croppedLabels.push(labels[i].slice(0, 12).concat('...'))
          } else {
            croppedLabels.push(labels[i])
          }
        }
        return croppedLabels
      }
      return labels
    },

    cropLabelsAndOrderDataAlphabetically(labels, associatedData) {
      labels = this.croppedLabels(labels)

      var visibilityData = {}
      labels.forEach((label, i) => (visibilityData[label] = associatedData[i]))
      const orderedVisibilityData = Object.keys(visibilityData)
        .sort(function (a, b) {
          if (a.includes('All ', 0)) {
            return 1
          } else if (b.includes('All ', 0)) {
            return -1
          } else if (a < b) {
            return -1
          }
          return 1
        })
        .reduce((obj, key) => {
          obj[key] = visibilityData[key]
          return obj
        }, {})
      return orderedVisibilityData
    },

    convertRGBtoHex(r, g, b) {
      return (
        '#' +
        this.componentToHex(r) +
        this.componentToHex(g) +
        this.componentToHex(b)
      )
    },

    componentToHex(c) {
      let hex = c.toString(16)
      return hex.length == 1 ? '0' + hex : hex
    },

    addBlackOrWhite(colorsArray) {
      if (this.$vuetify.theme.dark === true) {
        colorsArray.push('#FFFFFF')
      } else {
        colorsArray.push('#000000')
      }
      return colorsArray
    },

    createColorsArray(nbOfColors) {
      let colorsArray = []
      const randomHSLValue = (h) => [
        h,
        (Math.floor(Math.random() * (80 - 60 + 1)) + 80) / 100,
        (Math.floor(Math.random() * (50 - 40 + 1)) + 40) / 100
      ]
      let hValues = []
      for (let i = 0; i < nbOfColors; i++) {
        hValues.push(i / nbOfColors)
      }
      hValues.forEach((hue) => {
        const rgba = CesiumTools.hslToRgb(randomHSLValue(hue)).map((value) =>
          parseInt(value)
        )
        colorsArray.push(this.convertRGBtoHex(rgba[0], rgba[1], rgba[2]))
      })
      return colorsArray
    },

    convertSecondsToGUI(seconds) {
      let hours = Math.floor(seconds / 3600)
      let minutes = Math.floor((seconds - hours * 3600) / 60)
      let second = Math.floor(seconds - hours * 3600 - minutes * 60)
      let res = ''
      res += hours > 0 ? hours + 'h' : ''
      res += minutes > 0 || (hours > 0 && second > 0) ? minutes + 'mn' : ''
      res += second > 0 ? second + 's' : ''
      return res
    },

    computeDateFromDuration(secondsSinceStart) {
      if (this.currentResultsLog?.results?.missionStartDate) {
        let newDate = moment
          .utc(this.currentResultsLog.results.missionStartDate)
          .add(secondsSinceStart, 'seconds')
        return newDate.toDate()
      } else {
        return moment.utc().toDate()
      }
    },

    computeUTCDateFromDuration(secondsSinceStart) {
      if (this.currentResultsLog?.results?.missionStartDate) {
        let newDate = moment
          .utc(this.currentResultsLog.results.missionStartDate)
          .add(secondsSinceStart, 'seconds')
        return newDate.toISOString()
      } else {
        return moment.utc().toISOString()
      }
    },
    clean3DView() {
      delete this.viewer
      delete this.cartesianDataMulti
      this.cartesianDataMulti = [[]]
    },

    loadLayout() {
      if (
        this.currentMission?.typeName === 'ConstellationSimulationRequest' &&
        this.dataLoaded
      ) {
        Vue.nextTick(() => {
          this.updateMap()
        })
      }
    },

    requestComputation() {
      this.$router.push({ path: '/numericalconstellationmission' })
      Vue.nextTick(() => {
        // use nextTick to be sure mission components are created and can handle events
        this.$root.$emit('request-computation-constellation-simulation')
      })
    },

    updateMap() {
      this.updateIndex++
    },

    createCesiumImageLayerWithoutIon() {
      return [
        {
          name: 'Toner',
          url: 'https://stamen-tiles.a.ssl.fastly.net/toner/',
          tooltip:
            'A high contrast black and white map.nhttp://maps.stamen.com',
          iconUrl: 'http://a.tile.stamen.com/toner/12/658/1581.png'
        }
      ]
        .map((el) => {
          el.creationFunction = () => {
            return new Cesium.OpenStreetMapImageryProvider({
              url: el.url,
              tooltip: 'test',
              iconUrl: el.iconUrl,
              credit: el.name,
              ellipsoid: this.ellipsoid
            })
          }
          return new Cesium.ProviderViewModel(el)
        })
        .concat(
          [
            {
              name: 'Mapbox Satellite',
              tooltip: 'Mapbox satellite tiles',
              iconUrl: Cesium.buildModuleUrl(
                'Widgets/Images/ImageryProviders/mapboxSatellite.png'
              ),
              id: 'mapbox.satellite'
            }
          ].map((el) => {
            el.creationFunction = () => {
              return new Cesium.MapboxImageryProvider({
                name: el.name,
                mapId: el.id,
                iconUrl: el.iconUrl,
                tooltip: el.tooltip,
                ellipsoid: this.ellipsoid,
                accessToken: this.mapboxToken
              })
            }
            return new Cesium.ProviderViewModel(el)
          })
        )
    },

    prepareAndDisplayData() {
      this.buildingMap = true

      // When switching page, purge plotly context to avoid memory leaks and errors when resizing page
      // No catch if the plot didn't rendered
      // this.clean3DView()
      // this.draw3Dview()
      this.cleanGroundStationTimelines()
      this.prepareGroundStationTimeline()
      if (this.displayDistanceBetweenSpacecrafts) {
        this.drawDistanceGraph()
      }

      // this.prepareCesiumVisibilityOptions()
      // this.changeDistanceLineVisibility()
      // this.changePayloadConesVisibility()
      // this.changeGroundStationConesVisibility()
      this.prepareSpacecraftPOVTimeline()

      this.buildingMap = false
    },

    cleanCesiumVisbilityOptions() {
      this.availableCesiumConstellationPlane = []
    },

    prepareCesiumVisibilityOptions() {
      this.cleanCesiumVisbilityOptions()
      const constellationKeys = Object.keys(
        this.currentResultsLog.results.constellationsVisibilityData
      )

      this.cesiumConstellationSelectionCategory = 'Constellation Selection'
      this.cesiumConstellationPlaneCategory = 'Plane Selection'

      let initialArray = []

      for (let constellationKey of constellationKeys) {
        initialArray.push(
          this.currentResultsLog.results.constellationsVisibilityData[
            constellationKey
          ].constellation.name
        )
      }

      this.currentCesiumConstellationsLabel = initialArray

      this.changeConstellationsVisibility()
    },

    changeConstellationsVisibility() {
      if (this.currentCesiumConstellationsLabel.length === 1) {
        let initialPlaneSelection = []
        let constellationData =
          this.currentResultsLog.results.constellationsVisibilityData[
            this.currentCesiumConstellationsLabel
          ]
        let numberOfPlanes = constellationData.constellation.numberOfPlanes
        this.availableCesiumConstellationPlane = []
        for (let i = 1; i <= numberOfPlanes; i++) {
          this.availableCesiumConstellationPlane.push('Plane ' + String(i))
          initialPlaneSelection.push('Plane ' + String(i))
        }
        this.currentCesiumConstellationPlanesLabel = initialPlaneSelection
        this.changeConstellationsPlanesVisibility()
      } else {
        const keysData = this.cartesianDataMultiMap.keys()
        for (let keyData of keysData) {
          let keyElements = keyData.split(' - ')
          let constellationName = keyElements[0]

          if (
            this.checkElementInList(
              constellationName,
              this.currentCesiumConstellationsLabel
            )
          ) {
            this.czmlDataSource.entities.getById(keyData).show = true
            this.czmlDataSource.entities.getById(
              'point' + String(keyData)
            ).show = true
          } else {
            this.czmlDataSource.entities.getById(keyData).show = false
            this.czmlDataSource.entities.getById(
              'point' + String(keyData)
            ).show = false
          }
        }
      }
      this.changePayloadConesVisibility()
    },

    changeConstellationsPlanesVisibility() {
      const keysData = this.cartesianDataMultiMap.keys()

      for (let keyData of keysData) {
        let keyElements = keyData.split(' - ')
        let constellationName = keyElements[0]

        let planeindex = keyElements[1].split('-')
        let label = String('Plane ' + String(planeindex[1]))

        if (
          this.checkElementInList(
            label,
            this.currentCesiumConstellationPlanesLabel
          ) &&
          this.checkElementInList(
            constellationName,
            this.currentCesiumConstellationsLabel
          )
        ) {
          this.czmlDataSource.entities.getById(keyData).show = true
          this.czmlDataSource.entities.getById(
            'point' + String(keyData)
          ).show = true
        } else {
          this.czmlDataSource.entities.getById(keyData).show = false
          this.czmlDataSource.entities.getById(
            'point' + String(keyData)
          ).show = false
        }
      }
      this.changePayloadConesVisibility()
    },

    changePayloadConesVisibility() {
      const keysData = this.cartesianDataMultiMap.keys()
      for (let keyData of keysData) {
        let keyElements = keyData.split(' - ')
        let constellationName = keyElements[0]

        let planeindex = keyElements[1].split('-')
        let label = String('Plane ' + String(planeindex[1]))

        if (
          this.payloadConesValue === true &&
          this.checkElementInList(
            constellationName,
            this.currentCesiumConstellationsLabel
          )
        ) {
          if (this.currentCesiumConstellationsLabel.length > 1) {
            this.czmlDataSource.entities.getById(
              'payloadCone' + String(keyData)
            ).show = true
          } else if (
            this.checkElementInList(
              label,
              this.currentCesiumConstellationPlanesLabel
            )
          ) {
            this.czmlDataSource.entities.getById(
              'payloadCone' + String(keyData)
            ).show = true
          } else {
            this.czmlDataSource.entities.getById(
              'payloadCone' + String(keyData)
            ).show = false
          }
        } else {
          this.czmlDataSource.entities.getById(
            'payloadCone' + String(keyData)
          ).show = false
        }
      }
    },

    checkElementInList(element, array) {
      for (let a in array) {
        if (element === array[a]) {
          return true
        }
      }
      return false
    },

    changeGroundStationVisibility() {
      if (this.groundStationCheckboxValue === true) {
        this.currentResultsLog.results.groundStations.forEach(
          (groundStation) => {
            this.czmlDataSource.entities.getById(
              'point' + String(groundStation.name)
            ).show = true
          }
        )
      } else {
        this.currentResultsLog.results.groundStations.forEach(
          (groundStation) => {
            this.czmlDataSource.entities.getById(
              'point' + String(groundStation.name)
            ).show = false
          }
        )
      }
    },

    changeGroundStationConesVisibility() {
      if (this.groundStationConesCheckboxValue === true) {
        this.currentResultsLog.results.groundStations.forEach(
          (groundStation) => {
            this.czmlDataSource.entities.getById(
              'cone' + groundStation.name
            ).show = true
          }
        )
      } else {
        this.currentResultsLog.results.groundStations.forEach(
          (groundStation) => {
            this.czmlDataSource.entities.getById(
              'cone' + groundStation.name
            ).show = false
          }
        )
      }
    },

    getColor(index) {
      return this.constellationColors[index % this.constellationColors.length]
    },

    changeConstellationPlanesColor() {
      if (this.planesColorValue === true) {
        const keysData = this.cartesianDataMultiMap.keys()
        for (let keyData of keysData) {
          const keyElements = keyData.split(' - ')

          const planeindex = keyElements[1].split('-')

          let entity = this.czmlDataSource.entities.getById(keyData)
          let rgbaColor = this.getColor(planeindex[1])
          let color = new Cesium.Color(
            rgbaColor[0] / 255,
            rgbaColor[1] / 255,
            rgbaColor[2] / 255,
            rgbaColor[3] / 255
          )
          entity.path.material.outlineColor.setValue(color)
        }
      } else {
        const keysData = this.cartesianDataMultiMap.keys()
        for (let keyData of keysData) {
          let constellationName = keyData.split(' - ')[0]
          let entity = this.czmlDataSource.entities.getById(keyData)
          let rgbaColor = this.constellationColorsMap.get(constellationName)
          let color = new Cesium.Color(
            rgbaColor[0] / 255,
            rgbaColor[1] / 255,
            rgbaColor[2] / 255,
            rgbaColor[3] / 255
          )
          entity.path.material.outlineColor.setValue(color)
        }
      }
    },

    formatToCZMLAvailability(visibilityTimes) {
      if (visibilityTimes) {
        const misionStartDate = moment.utc(
          this.currentResultsLog.results.missionStartDate
        )
        const visibilityTimesFormatted = []
        visibilityTimes.forEach((visibilityTime) => {
          visibilityTimesFormatted.push(
            moment(misionStartDate.toISOString())
              .add(visibilityTime.start, 'seconds')
              .toISOString() +
              '/' +
              moment(misionStartDate.toISOString())
                .add(visibilityTime.end, 'seconds')
                .toISOString()
          )
        })
        return visibilityTimesFormatted
      }
      return []
    },

    addVisibilityLineBetweengroundStationAndSpacecraft() {
      if (this.currentResultsLog.results.groundStations.length) {
        const keys = Object.keys(
          this.currentResultsLog.results.constellationsVisibilityData
        )
        keys.forEach((key) => {
          this.currentResultsLog.results.groundStations.forEach(
            (groundStation) => {
              const spaceCraftsName = this.cartesianDataMultiMap.keys()
              for (const spacecraftName of spaceCraftsName) {
                const sapcecraftData = spacecraftName.split(' - ')
                const constellation = sapcecraftData[0]
                let plane = sapcecraftData[1]
                let spacecraftIndex = sapcecraftData[2]
                let spacecraftLabel =
                  constellation +
                  this.ID_SEPARATOR +
                  plane +
                  this.ID_SEPARATOR +
                  spacecraftIndex
                const visibilityTimes = this.formatToCZMLAvailability(
                  this.currentResultsLog.results.constellationsVisibilityData[
                    key
                  ].groundStationsVisibilityIntervals[groundStation.name]
                    .stationVisibilityTimeline[spacecraftLabel]
                )
                if (visibilityTimes.length > 0) {
                  this.czml.push(
                    this.initLinesBetweenGroundStationsAndSpacecrafts(
                      groundStation.name,
                      spacecraftName,
                      visibilityTimes
                    )
                  )
                }
              }
            }
          )
        })
      }
    },

    initLinesBetweenGroundStationsAndSpacecrafts(
      groundstation,
      spacecraft,
      visibilityTimes
    ) {
      let line = {
        id: 'distanceLine' + String(groundstation) + '/' + String(spacecraft),
        name: 'distanceLine',
        availability: visibilityTimes,
        arcType: 'NONE',
        width: 1,
        polyline: {
          positions: {
            references: [
              String('groundStation' + String(groundstation) + '#position'),
              String('point' + String(spacecraft) + '#position')
            ]
          },
          material: {
            solidColor: {
              color: {
                rgba: [255, 0, 255, 255]
              }
            }
          }
        }
      }
      return line
    },

    changeDistanceLineVisibility() {
      if (this.cartesianDataMultiMap != null) {
        const keysData = this.cartesianDataMultiMap.keys()
        const self = this

        if (this.distanceLineCheckboxValue === false) {
          for (let key of keysData) {
            const keysDataCopy = this.cartesianDataMultiMap.keys()
            let point = this.czmlDataSource.entities.getById(
              'point' + String(key)
            )
            point.point.outlineWidth = 1

            for (let key2 of keysDataCopy) {
              let line = self.czmlDataSource.entities.getById(
                'distanceLine' + String(key) + '/' + String(key2)
              )

              if (line !== undefined) {
                line.show = false
              }
            }
          }
        } else {
          const regex = new RegExp(this.ID_SEPARATOR, 'g')
          let label1 = String(this.currentSpacecraftOneLabel).replace(
            regex,
            ' - '
          )

          let label2 = String(this.currentSpacecraftTwoLabel).replace(
            regex,
            ' - '
          )

          for (let key of keysData) {
            const keysDataCopy = this.cartesianDataMultiMap.keys()
            let point = this.czmlDataSource.entities.getById(
              'point' + String(key)
            )
            point.point.outlineWidth = 1

            for (let key2 of keysDataCopy) {
              let line = self.czmlDataSource.entities.getById(
                'distanceLine' + String(key) + '/' + String(key2)
              )

              if (line !== undefined) {
                line.show = false
              }
            }
          }

          let line1 = this.czmlDataSource.entities.getById(
            'distanceLine' + String(label1) + '/' + String(label2)
          )
          let line2 = this.czmlDataSource.entities.getById(
            'distanceLine' + String(label2) + '/' + String(label1)
          )

          if (line1 !== undefined) {
            line1.show = true
          } else {
            line2.show = true
          }

          let point1 = this.czmlDataSource.entities.getById(
            'point' + String(label1)
          )
          let point2 = this.czmlDataSource.entities.getById(
            'point' + String(label2)
          )
          point1.point.outlineWidth = 5
          point2.point.outlineWidth = 5
        }
      }
    },

    computeHighestInitialAltitudeOfConstellatiions() {
      let altitude = 10

      const keys = Object.keys(
        this.currentResultsLog.results.constellationsVisibilityData
      )

      for (let key of keys) {
        let constellationData =
          this.currentResultsLog.results.constellationsVisibilityData[key]
        let constellationAltitude =
          constellationData.constellation.plane.altitude

        if (constellationAltitude >= altitude) {
          altitude = constellationAltitude
        }
      }
      return altitude
    },

    computeOrbitalPeriod(altitude) {
      let earthRadiusEGM96 = 6378136.3
      let earthMU = 3.986004415e14

      return (
        2 *
        Math.PI *
        Math.sqrt(Math.pow(altitude + earthRadiusEGM96, 3) / earthMU)
      )
    },

    addGroundStations() {
      this.groundStationsCones = []
      if (this.currentResultsLog?.results?.groundStations?.length > 0) {
        this.currentResultsLog.results.groundStations.forEach((groundStation) =>
          this.czml.push(this.drawGroundStation(groundStation))
        )
      }
    },

    drawPointOfInterest(pointOfInterest) {
      let point = {
        id: 'pointOfInterest' + String(pointOfInterest.name),
        name: 'point of interest' + String(pointOfInterest.name),

        position: {
          cartographicDegrees: [
            pointOfInterest.longitude * (180 / Math.PI),
            pointOfInterest.latitude * (180 / Math.PI),
            10
          ]
        },
        point: {
          color: {
            rgba: [255, 255, 255, 255]
          },
          outlineColor: {
            rgba: [255, 0, 0, 255]
          },
          outlineWidth: 5,
          pixelSize: 5
        }
      }

      point['label'] = {
        fillColor: {
          rgba: [255, 255, 255, 255]
        },
        font: '13pt Lucida Console',
        horizontalOrigin: 'LEFT',
        outlineColor: {
          rgba: [150, 0, 150, 255]
        },
        outlineWidth: 3,
        pixelOffset: {
          cartesian2: [20, 0]
        },
        style: 'FILL_AND_OUTLINE',
        text: String(pointOfInterest.name)
      }

      return point
    },

    addIsolatedPointsOfInterest() {
      if (
        this.currentResultsLog?.results?.isolatedPointsOfInterest?.length > 0
      ) {
        this.currentResultsLog.results.isolatedPointsOfInterest.forEach(
          (pointOfInterest) =>
            this.czml.push(this.drawPointOfInterest(pointOfInterest))
        )
      }
    },

    addGroundStationsCones() {
      const self = this

      this.groundStationsCones = []
      this.currentResultsLog.results.groundStations.forEach((groundStation) => {
        let cone = {
          id: 'cone' + groundStation.name,
          name: 'cone' + groundStation.name,

          position: {
            cartographicDegrees: [
              groundStation.longitude * (180 / Math.PI),
              groundStation.latitude * (180 / Math.PI),
              10
            ]
          },

          cylinder: {
            material: {
              solidColor: {
                color: {
                  rgba: [255, 0, 0, 100]
                }
              }
            },
            length: this.computeHighestInitialAltitudeOfConstellatiions(),
            topRadius:
              this.computeHighestInitialAltitudeOfConstellatiions() *
              Math.tan(Math.PI / 2 - groundStation.minElevation),
            bottomRadius: 0,
            heightReference: 'CLAMP_TO_GROUND'
          }
        }

        self.czml.push(cone)
      })
    },

    prepareGroundStationTimeline() {
      this.availableGroundStations = []
      this.availableConstellations = []
      this.availableConstellationPlanes = []
      this.availableConstellationInPlaneSpacecrafts = []

      this.timelineGroundStationCategory = 'Ground Station'
      this.timelineCategory = 'Ground station visibility'
      this.timelineConstellationCategory = 'Constellation'
      this.timelinePlaneCategory = 'Constellation Plane'

      const keysThreed = Object.keys(
        this.currentResultsLog.results.threedEphemerides
      )

      this.currentSpacecraftOneLabel = keysThreed[0]
      this.currentSpacecraftTwoLabel = keysThreed[1]

      this.displayGroundStationTimeline()
    },

    prepareSpacecraftPOVTimeline() {
      this.spacecraftPOVTimelineConstellationsCategory = 'Constellation'
      this.spacecraftPOVTimelinePlanesCategory = 'Plane'
      this.spacecraftPOVTimelineSpacecraftCategory = 'Spacecraft Index In Plane'

      this.displaySpacecraftPOVTimeline()
    },

    displaySpacecraftPOVTimeline() {
      this.cleanSpacecraftPOVTimeline()

      if (
        this.currentResultsLog?.results?.constellationsVisibilityData != null
      ) {
        const keysConstellation = Object.keys(
          this.currentResultsLog.results.constellationsVisibilityData
        )
        if (this.currentSpacecraftPOVTimelineConstellationsLabel === null) {
          this.currentSpacecraftPOVTimelineConstellationsLabel =
            this.currentResultsLog.results.constellationsVisibilityData[
              keysConstellation[0]
            ].constellation.name
        }
        keysConstellation.forEach((keyConstellation) => {
          let constellationData =
            this.currentResultsLog.results.constellationsVisibilityData[
              keyConstellation
            ]
          if (
            constellationData.constellation.name ===
            this.currentSpacecraftPOVTimelineConstellationsLabel
          ) {
            let keysSpacecrafts = Object.keys(
              constellationData.spacecraftVisibilityIntervals
            )
            for (let keySpacecraft of keysSpacecrafts) {
              const keyElements = keySpacecraft.split(this.ID_SEPARATOR)
              const planeIndex = keyElements[1]
              const spacecraftIndex = keyElements[2]
              this.availableSpacecraftPOVTimelineConstellationPlanes.push(
                planeIndex
              )
              this.availableSpacecraftPOVTimelineSpacecraftInPlanes.push(
                spacecraftIndex
              )
              this.currentSpacecraftPOVTimelineConstellationPlaneLabel =
                planeIndex
              this.currentSpacecraftPOVTimelineSpacecraftIndexLabel =
                spacecraftIndex
            }
          }
        })
        this.drawSpacecraftTimeline()
      }
    },

    displayGroundStationTimeline() {
      this.cleanGroundStationTimelines()
      if (
        this.currentResultsLog != null &&
        this.currentResultsLog.results != null &&
        this.currentResultsLog.results.groundStations != null &&
        this.currentResultsLog.results.groundStations.length > 1
      ) {
        this.availableGroundStations.push('All Stations')
      }
      this.currentResultsLog.results.groundStations.forEach((groundStation) =>
        this.availableGroundStations.push(groundStation.name)
      )
      if (
        this.currentResultsLog?.results?.constellationsVisibilityData != null
      ) {
        const keysConstellation = Object.keys(
          this.currentResultsLog.results.constellationsVisibilityData
        )

        if (
          this.currentGroundStationLabel == null &&
          this.currentResultsLog?.results?.groundStations?.length > 0
        ) {
          this.currentGroundStationLabel =
            this.currentResultsLog.results.groundStations[0].name
        }
        if (this.currentConstellationLabel == null) {
          this.currentConstellationLabel =
            this.currentResultsLog.results.constellationsVisibilityData[
              keysConstellation[0]
            ].constellation.name
        }

        keysConstellation.forEach((keyConstellation) => {
          let constellationData =
            this.currentResultsLog.results.constellationsVisibilityData[
              keyConstellation
            ]
          this.availableConstellations.push(
            constellationData.constellation.name
          )
          if (
            constellationData.constellation.name ===
            this.currentConstellationLabel
          ) {
            let keysGroundStation = Object.keys(
              constellationData.groundStationsVisibilityIntervals
            )

            keysGroundStation.forEach((keyGroundStation) => {
              let groundStation =
                constellationData.groundStationsVisibilityIntervals[
                  keyGroundStation
                ]
              if (
                groundStation.groundStationName ===
                this.currentGroundStationLabel
              ) {
                this.groundStationInformation = groundStation

                const keys = Object.keys(
                  groundStation.stationVisibilityTimeline
                )
                for (let key of keys) {
                  const keyElements = key.split(this.ID_SEPARATOR)
                  const planeIndex = keyElements[1]
                  const spacecraftIndex = keyElements[2]
                  this.availableConstellationPlanes.push(planeIndex)
                  this.availableConstellationInPlaneSpacecrafts.push(
                    spacecraftIndex
                  )
                  this.currentPlaneLabel = planeIndex
                  this.currentInPlaneSpacecraftIndexLabel = spacecraftIndex

                  const isDefault = planeIndex.startsWith('AllPlanes')
                  this.addTimeline(
                    key,
                    groundStation.stationVisibilityTimeline[key],
                    isDefault
                  )
                }

                if (this.currentPlaneLabel === null) {
                  this.currentPlaneLabel = 'All Planes'
                }
                if (this.currentInPlaneSpacecraftIndexLabel === null) {
                  this.currentInPlaneSpacecraftIndexLabel = 'All Spacecrafts'
                }
                this.drawGroundStationTimeline()
              }
            })
          }
        })
      }
    },

    addTimeline(key, intervals, isDefault) {
      const regex = new RegExp(this.ID_SEPARATOR, 'g')
      const label = key.replace(regex, ' - ')

      this.availableTimelines.push(label)
      this.availableTimelines.sort()
      this.timelineIntervals[label] = intervals
    },

    cleanTimelines() {
      this.cleanGroundStationTimelines()
      this.cleanSpacecraftTimelines()
    },

    cleanSpacecraftPOVTimeline() {
      this.availableSpacecraftPOVTimelineConstellationPlanes = []
      this.availableSpacecraftPOVTimelineSpacecraftInPlanes = []
    },

    cleanSpacecraftTimelines() {
      this.currentSpacecraftOneLabel = null
      this.currentSpacecraftTwoLabel = null
      this.currentSpacecraftTimelineLabel = null
      this.currentSpacecraftPayloadTimelineLabel = null

      this.availableSpacecrafts = []

      this.spacecraftCategoryOne = ''
      this.spacecraftCategoryTwo = ''
      this.timelineCategory = ''
      this.timelineCategory = ''
    },

    cleanGroundStationTimelines() {
      this.availableTimelines = []
      this.availableConstellations = []
      this.availableGroundStations = []
      this.availableConstellationPlanes = []

      this.timelineIntervals = {}
      this.timelineCategory = ''
      this.timelineGroundStationCategory = ''
      this.cleanGroundStationTimelineView()
    },

    cleanGroundStationTimelineView() {
      d3.select('#groundStationTimeline')
        .selectAll('svg')
        .remove()
        .selectAll('rect')
        .remove()
    },

    cleanSpacecraftTimelineView() {
      d3.select('#spacecraftTimeline')
        .selectAll('svg')
        .remove()
        .selectAll('rect')
        .remove()
    },

    cleanSpacecraftPayloadTimelineView() {
      d3.select('#spacecraftPayloadTimeline')
        .selectAll('svg')
        .remove()
        .selectAll('rect')
        .remove()
    },
    cleanPointOfInterestTimelineView() {
      d3.select('#pointOfInterestTimeline')
        .selectAll('svg')
        .remove()
        .selectAll('rect')
        .remove()
    },

    drawDataGraph() {
      // cleanGraph

      const regex = new RegExp(this.ID_SEPARATOR, 'g')

      let constellation = this.currentSpacecraftPOVTimelineConstellationsLabel
      let plane = this.currentSpacecraftPOVTimelineConstellationPlaneLabel
      let spacecraftIndex =
        this.currentSpacecraftPOVTimelineSpacecraftIndexLabel
      let currentDataSpacecraftLabel =
        constellation +
        this.ID_SEPARATOR +
        plane +
        this.ID_SEPARATOR +
        spacecraftIndex

      let data = this.currentResultsLog.results.data[currentDataSpacecraftLabel]
      let datas = []

      let dates =
        this.currentResultsLog.results.dates[currentDataSpacecraftLabel]

      let newDates = []

      let initialDateString = this.currentResultsLog.results.missionStartDate

      this.initialDate = moment.utc(initialDateString)
      for (let i = 0; i < data.length; i++) {
        datas.push(dataTools.convertSi2gui('data', data[i]))
        let newDate = moment.utc(
          this.currentResultsLog.results.missionStartDate
        )

        newDate.add(dates[i], 'seconds')

        newDates.push(newDate.toISOString())
      }

      let dataMax = datas.reduce(function (a, b) {
        return Math.max(a, b)
      })

      let dataMin = datas.reduce(function (a, b) {
        return Math.min(a, b)
      })

      const plotDom = document.getElementById('idDataSpacecrafts')
      if (plotDom) {
        try {
          Plotly.purge('idDataSpacecrafts')
        } catch (e) {}
      }

      if (this.currentMission.layout) {
        let missionLayout = JSON.parse(this.currentMission.layout)
        dataTools.loadGridLayoutConfig(missionLayout, this)
      } else {
        let missionLayout = { configurations: [], layout: this.defaultLayout }
        dataTools.loadGridLayoutConfig(missionLayout, this)

        let data = [
          {
            x: newDates,
            y: datas,
            type: 'scatter',
            mode: 'lines'
          }
        ]
        let layout = {
          margin: {
            t: 0,
            b: 50
          },
          height: 300,
          xaxis: {
            title: {
              text: 'Date (UTC)',
              font: {
                color: this.$vuetify.theme.dark ? 'white' : '#121212'
              }
            },
            tickfont: {
              color: this.$vuetify.theme.dark ? 'white' : '#121212'
            },
            gridcolor: this.$vuetify.theme.dark
              ? this.$vuetify.theme.currentTheme.secondary
              : '',
            showline: false,
            showgrid: true,
            zeroline: true
          },
          yaxis: {
            title: {
              text: 'Data (' + dataTools.getDefaultGuiUnit('data') + ')',
              font: {
                color: this.$vuetify.theme.dark ? 'white' : '#121212'
              }
            },
            tickfont: {
              color: this.$vuetify.theme.dark ? 'white' : '#121212'
            },
            gridcolor: this.$vuetify.theme.dark
              ? this.$vuetify.theme.currentTheme.secondary
              : '',
            showline: false,
            showgrid: true,
            zeroline: true
            // rangemode: 'tozero'
          },
          plot_bgcolor: this.$vuetify.theme.dark ? 'rgba(0,0,0,0)' : 'white',
          paper_bgcolor: this.$vuetify.theme.dark ? 'rgba(0,0,0,0)' : 'white',
          autosize: true
        }

        if (dataMax - dataMin < 10) {
          let ylim = [dataMin - 10, dataMax + 10]
          layout.yaxis.range = [ylim[0], ylim[1]]
        }

        Plotly.react('idDataSpacecrafts', data, layout, { responsive: true })
      }
    },

    drawDistanceGraph() {
      // cleanGraph
      if (this.cartesianDataMultiMap != null) {
        const regex = new RegExp(this.ID_SEPARATOR, 'g')

        let label1 = String(this.currentSpacecraftOneLabel).replace(
          regex,
          ' - '
        )

        let label2 = String(this.currentSpacecraftTwoLabel).replace(
          regex,
          ' - '
        )

        let sat1 =
          this.currentResultsLog.results.threedEphemerides[
            this.currentSpacecraftOneLabel
          ]
        let sat2 =
          this.currentResultsLog.results.threedEphemerides[
            this.currentSpacecraftTwoLabel
          ]

        let content = [sat1, sat2]

        this.$http
          .post(
            dashboardTools.getCurrentAPI(this) + '/distance_graph/',
            content
          )
          .then((response) => {
            this.drawDistance(response)
          })

        const self = this

        const keysData = this.cartesianDataMultiMap.keys()

        // Reset Lines and points

        for (let key of keysData) {
          const keysDataCopy = this.cartesianDataMultiMap.keys()
          let point = this.czmlDataSource.entities.getById(
            'point' + String(key)
          )
          point.point.outlineWidth = 1

          for (let key2 of keysDataCopy) {
            let line = self.czmlDataSource.entities.getById(
              'distanceLine' + String(key) + '/' + String(key2)
            )

            if (line !== undefined) {
              line.show = false
            }
          }
        }

        let line1 = this.czmlDataSource.entities.getById(
          'distanceLine' + String(label1) + '/' + String(label2)
        )
        let line2 = this.czmlDataSource.entities.getById(
          'distanceLine' + String(label2) + '/' + String(label1)
        )

        if (line1 !== undefined) {
          line1.show = true
        } else {
          line2.show = true
        }

        let point1 = this.czmlDataSource.entities.getById(
          'point' + String(label1)
        )
        let point2 = this.czmlDataSource.entities.getById(
          'point' + String(label2)
        )
        point1.point.outlineWidth = 5
        point2.point.outlineWidth = 5
      }
    },

    drawDistance(response) {
      let dates = []
      let distances = []
      let initialDateString = this.currentResultsLog.results.missionStartDate

      this.initialDate = moment.utc(initialDateString)
      for (let i = 0; i < response.data.length; i++) {
        let newDate = moment.utc(
          this.currentResultsLog.results.missionStartDate
        )

        newDate.add(response.data[i][0], 'seconds')

        dates.push(newDate.toISOString())
        distances.push(response.data[i][1])
      }

      let distanceMax = distances.reduce(function (a, b) {
        return Math.max(a, b)
      })

      let distanceMin = distances.reduce(function (a, b) {
        return Math.min(a, b)
      })

      const plotDom = document.getElementById('idDistanceSpacecrafts')
      if (plotDom) {
        try {
          Plotly.purge('idDistanceSpacecrafts')
        } catch (e) {}
      }

      if (this.currentMission.layout) {
        let missionLayout = JSON.parse(this.currentMission.layout)
        dataTools.loadGridLayoutConfig(missionLayout, this)
      } else {
        let missionLayout = { configurations: [], layout: this.defaultLayout }
        dataTools.loadGridLayoutConfig(missionLayout, this)

        let data = [
          {
            x: dates,
            y: distances,
            type: 'scatter',
            mode: 'lines'
          }
        ]
        let layout = {
          // title: {
          //   text: 'Distance between' + this.currentSpacecraftOneLabel + 'and' + this.currentSpacecraftTwoLabel,
          //   font: {
          //     family: 'Times New Roman',
          //     size: 12
          //   }

          // },
          margin: {
            t: 0,
            b: 50
          },
          height: 300,
          xaxis: {
            title: {
              text: 'Date (UTC)'
            },
            showline: false,
            showgrid: true,
            zeroline: true
          },
          yaxis: {
            title: {
              text: 'Distance (km)'
            },
            showline: false,
            showgrid: true,
            zeroline: true
            // rangemode: 'tozero'
          },
          autosize: true
        }

        if (distanceMax - distanceMin < 10) {
          let ylim = [distanceMin - 100, distanceMax + 100]
          layout.yaxis.range = [ylim[0], ylim[1]]
        }

        Plotly.react('idDistanceSpacecrafts', data, layout, {
          responsive: true
        })
      }
    },

    addVisibilityLine() {
      const self = this
      let label1 = 'Cork'
      const keysData = this.cartesianDataMultiMap.keys()
      for (let key of keysData) {
        self.czml.push(self.initDistanceLine(label1, key))
      }
    },

    addDistanceLines() {
      const self = this

      const keysData = this.cartesianDataMultiMap.keys()

      let distanceLineMap = new Map()

      for (let key of keysData) {
        const keysDatacopy = this.cartesianDataMultiMap.keys()
        for (let key2 of keysDatacopy) {
          if (key2 !== key) {
            if (
              distanceLineMap.get(key + key2) === undefined &&
              distanceLineMap.get(key2 + key) === undefined
            ) {
              distanceLineMap.set(key + key2, 1)
              self.czml.push(self.initDistanceLine(key, key2))
            }
          }
        }
      }
    },

    initConstellationColors() {
      const constellationsKeys = Object.keys(
        this.currentResultsLog.results.constellationsVisibilityData
      )
      let count = 0
      this.constellationColorsMap = new Map()
      for (let key of constellationsKeys) {
        let constellationData =
          this.currentResultsLog.results.constellationsVisibilityData[key]
        this.constellationColorsMap.set(
          constellationData.constellation.name,
          this.getColor(count)
        )
        count = count + 1
      }
    },

    draw3Dview() {
      this.clean3DView()

      this.spacecraftCategoryOne = 'First spacecraft'
      this.spacecraftCategoryTwo = 'Second spacecraft'

      const container = document.getElementById(this.idWidget3DView)

      const offlineConfig =
        this.userSettings?.standardConfigurations?.['Cesium offline'] ??
        this.defaultUserSettings?.standardConfigurations?.['Cesium offline'] ??
        this.localDefaultUserSettings?.standardConfigurations?.[
          'Cesium offline'
        ] ??
        false
      const offline = offlineConfig === true

      if (container != null) {
        container.innerHTML = ''
        let globe = new Cesium.Globe(this.ellipsoid)
        this.viewer = new Cesium.Viewer(this.idWidget3DView, {
          imageryProviderViewModels: offline
            ? this.createCesiumImageLayerOffline()
            : this.createCesiumImageLayerWithoutIon(),
          terrainProviderViewModels: [],
          selectionIndicator: false,
          timeline: true,
          baseLayerPicker: true,
          animation: true,
          vrButton: false,
          geocoder: false,
          navigationHelpButton: false,
          requestRenderMode: true,
          globe: globe,
          shouldAnimate: true
        })
        const self = this

        const elem = document.querySelector('.cesium-widget-credits')
        elem.parentNode.removeChild(elem)
        let viewer = this.viewer

        let imageryLayers = viewer.imageryLayers
        imageryLayers.removeAll()
        imageryLayers.addImageryProvider(
          new Cesium.OpenStreetMapImageryProvider({
            url: 'https://stamen-tiles.a.ssl.fastly.net/toner/',
            credit:
              'Map tiles by Stamen Design, under CC BY 3.0. Data by OpenStreetMap, under CC BY SA.',
            ellipsoid: this.ellipsoid
          })
        )

        let initialDateString = this.currentResultsLog.results.missionStartDate
        let finalDateString = this.currentResultsLog.results.missionEndDate

        let fieldIndexes = this.currentResultsLog.results.threedFieldIndexes
        this.cartesianDataMultiMap = new Map()
        this.cartesianGroundProjectionDataMultiMap = new Map()
        this.initialDate = new Date(Date.parse(initialDateString))
        this.finalDate = new Date(Date.parse(finalDateString))
        this.czml = [this.initCzml()]

        const keysThreed = Object.keys(
          this.currentResultsLog.results.threedEphemerides
        )

        const regex = new RegExp(this.ID_SEPARATOR, 'g')

        this.initConstellationColors()
        let projection = new Cesium.GeographicProjection(this.ellipsoid)

        for (let key of keysThreed) {
          this.availableSpacecrafts.push(key)
          let label = key.replace(regex, ' - ')
          let data = dataTools.convertSimulationData(
            this.currentResultsLog.results.threedEphemerides[key],
            fieldIndexes
          )

          let coordinatesData = []
          let coordinatesGroundProjectionData = []
          data.forEach((el) => {
            coordinatesData.push(
              el.simulationDuration,
              el.threedCartesianX,
              el.threedCartesianY,
              el.threedCartesianZ,
              el.threedCartesianVX,
              el.threedCartesianVY,
              el.threedCartesianVZ
            )

            let cartesianCoordinates = new Cesium.Cartesian3(
              el.threedCartesianX,
              el.threedCartesianY,
              el.threedCartesianZ
            )
            let cartographicCoordinates =
              Cesium.Cartographic.fromCartesian(cartesianCoordinates)
            let groundCoordinates = new Cesium.Cartesian3.fromRadians(
              cartographicCoordinates.longitude,
              cartographicCoordinates.latitude,
              10,
              this.ellipsoid
            )
            coordinatesGroundProjectionData.push(
              el.simulationDuration,
              groundCoordinates.x,
              groundCoordinates.y,
              groundCoordinates.z,
              el.threedCartesianVX,
              el.threedCartesianVY,
              el.threedCartesianVZ
            )
          })

          this.cartesianDataMultiMap.set(label, coordinatesData)
          this.cartesianGroundProjectionDataMultiMap.set(
            label,
            coordinatesGroundProjectionData
          )

          self.czml.push(self.initTrace(label))
          self.czml.push(self.drawSpacecraftPoint(label))
          self.czml.push(self.drawSpacecraftPayloadCone(label))
          // self.czml.push(self.drawPayloadTraces(label))
        }

        this.addGroundStationsCones()
        this.addDistanceLines()
        this.addVisibilityLine()
        this.addGroundStations()
        this.addIsolatedPointsOfInterest()
        this.addVisibilityLineBetweengroundStationAndSpacecraft()

        this.czmlDataSource = new Cesium.CzmlDataSource()

        this.viewer.dataSources.add(this.czmlDataSource)
        this.czmlDataSource.load(this.czml)
      }

      this.updateTimelineCursors()
    },

    initDistanceLine(spacecraftOne, spacecraftTwo) {
      let line = {
        id:
          'distanceLine' + String(spacecraftOne) + '/' + String(spacecraftTwo),
        name: 'distanceLine',

        polyline: {
          positions: {
            references: [
              String('point' + String(spacecraftOne) + '#position'),
              String('point' + String(spacecraftTwo) + '#position')
            ]
          },
          material: {
            solidColor: {
              color: {
                rgba: [255, 0, 0, 255]
              }
            }
          },
          arcType: 'NONE',
          width: 1
        }
      }
      return line
    },

    drawSpacecraftPayloadCone(name) {
      const keyElements = name.split(' - ')
      const constellationName = keyElements[0]
      let angle =
        this.currentResultsLog.results.constellationsVisibilityData[
          constellationName
        ].constellation.payload.fieldOfView
          .semiViewAngleAlongTrackOperatingAltitude
      let altitude =
        this.currentResultsLog.results.constellationsVisibilityData[
          constellationName
        ].constellation.plane.altitude
      let cone = {
        id: 'payloadCone' + String(name),
        name: 'payloadCone' + String(name),

        cylinder: {
          material: {
            solidColor: {
              color: {
                rgba: [50, 0, 255, 100]
              }
            }
          },
          length: altitude,
          topRadius: 0,
          bottomRadius: altitude * Math.tan(angle),
          height:
            this.currentResultsLog.results.constellationsVisibilityData[
              constellationName
            ].constellation.plane.altitude,
          heightReference: 'CLAMP_TO_GROUND'
        }
      }

      cone['position'] = {
        referenceFrame: 'FIXED',
        epoch: this.initialDate.toISOString(),
        cartesianVelocity: this.cartesianDataMultiMap.get(name)
      }
      return cone
    },

    drawSpacecraftPoint(name) {
      let point = {
        id: 'point' + String(name),
        name: 'point' + String(name),
        description: '<p>Point</p>',
        point: {
          color: {
            rgba: [255, 255, 255, 255]
          },
          outlineColor: {
            rgba: [255, 0, 0, 255]
          },
          outlineWidth: 1,
          pixelSize: 5
        }
      }

      point['position'] = {
        referenceFrame: 'FIXED',
        epoch: this.initialDate.toISOString(),
        cartesianVelocity: this.cartesianDataMultiMap.get(name)
      }

      return point
    },

    drawGroundStation(groundStation) {
      let point = {
        id: 'groundStation' + String(groundStation.name),
        name: 'groundStation' + String(groundStation.name),

        position: {
          cartographicDegrees: [
            groundStation.longitude * (180 / Math.PI),
            groundStation.latitude * (180 / Math.PI),
            10
          ]
        },
        point: {
          color: {
            rgba: [255, 255, 255, 255]
          },
          outlineColor: {
            rgba: [255, 255, 0, 255]
          },
          outlineWidth: 5,
          pixelSize: 5
        }
      }

      point['label'] = {
        fillColor: {
          rgba: [255, 255, 255, 255]
        },
        font: '13pt Lucida Console',
        horizontalOrigin: 'LEFT',
        outlineColor: {
          rgba: [150, 0, 150, 255]
        },
        outlineWidth: 3,
        pixelOffset: {
          cartesian2: [20, 0]
        },
        style: 'FILL_AND_OUTLINE',
        text: String(groundStation.name)
      }

      return point
    },

    drawPayloadTraces(name) {
      const keyElements = name.split(' - ')
      const constellationName = keyElements[0]
      let trace = {
        id: 'payloadTrace' + String(name),
        name: 'payloadTrace' + String(name),
        description: '<p>Path trace</p>',
        availability:
          this.initialDate.toISOString() + '/' + this.finalDate.toISOString(),
        path: {
          material: {
            polylineOutline: {
              outlineColor: {
                rgba: this.constellationColorsMap.get(constellationName)
              },
              outlineWidth: 5
            }
          },
          width: 1,
          leadTime: 0
        }
      }

      trace['position'] = {
        referenceFrame: 'FIXED',
        epoch: this.initialDate.toISOString(),
        cartesianVelocity: this.cartesianGroundProjectionDataMultiMap.get(name)
      }
      return trace
    },

    initTrace(name) {
      const keyElements = name.split(' - ')
      const constellationName = keyElements[0]
      const planeindex = keyElements[1].split('-')
      const spindex = keyElements[2].split('-')
      let altitude =
        this.currentResultsLog.results.constellationsVisibilityData[
          constellationName
        ].constellation.plane.altitude
      let numberOfSpacecraftInPlane =
        this.currentResultsLog.results.constellationsVisibilityData[
          constellationName
        ].constellation.numberOfSpacecraftsPerPlane

      let trace = {
        id: String(name),
        name: String(name),
        description: '<p>Path trace</p>',
        availability:
          this.initialDate.toISOString() + '/' + this.finalDate.toISOString(),
        path: {
          material: {
            polylineOutline: {
              outlineColor: {
                rgba: this.constellationColorsMap.get(constellationName)
              },
              outlineWidth: 5
            }
          },
          width: 1,
          leadTime: 0,
          trailTime:
            this.computeOrbitalPeriod(altitude) / numberOfSpacecraftInPlane
        }
      }

      trace['position'] = {
        referenceFrame: 'FIXED',
        epoch: this.initialDate.toISOString(),
        cartesianVelocity: this.cartesianDataMultiMap.get(name)
      }

      trace['label'] = {
        fillColor: {
          rgba: [255, 255, 255, 255]
        },
        font: '13pt Lucida Console',
        horizontalOrigin: 'LEFT',
        outlineColor: {
          rgba: [150, 0, 150, 255]
        },
        outlineWidth: 3,
        pixelOffset: {
          cartesian2: [20, 0]
        },
        style: 'FILL_AND_OUTLINE',
        text: planeindex[1] + '/' + spindex[1]
      }

      return trace
    },

    initCzml() {
      return {
        id: 'document',
        name: 'CZML Document',
        version: '1.0',
        clock: {
          interval:
            this.initialDate.toISOString() + '/' + this.finalDate.toISOString(),
          currentTime: this.initialDate.toISOString(),
          multiplier: 100
        }
      }
    },

    convertToHourFormat(seconds) {
      let hours = Math.floor(seconds / 3600)
      let minutes = Math.floor((seconds - hours * 3600) / 60)
      let second = Math.floor(seconds - hours * 3600 - minutes * 60)

      return String(hours + 'h ' + minutes + 'min ' + second) + 's '
    },

    updateTimelineCursors() {
      setTimeout(() => {
        try {
          this.updateTimelineCursor(
            '#timelineCursor',
            '#timelinePointCursor',
            this.scaleX,
            10
          )
          this.updateTimelineCursor(
            '#timelineCursorSpacecraftFromGround',
            '#timelinePointCursorSpacecraftFromGround',
            this.scaleXSpacecraftFromGround,
            0
          )
          this.updateTimelineCursor(
            '#timelineCursorGroundFromSpacecraft',
            '#timelinePointCursorGroundFromSpacecraft',
            this.scaleXGroundFromSpacecraft,
            0
          )
          this.updateTimelineCursor(
            '#timelineCursorPoIFromSpacecraft',
            '#timelinePointCursorPoIFromSpacecraft',
            this.scaleXPoIFromSpacecraft,
            0
          )

          this.updateTimelineCursors()
        } catch (error) {
          if (error instanceof TypeError) {
            this.updateTimelineCursors()
          }
        }
      }, 100)
    },

    updateTimelineCursor(cursorId, pointCursorId, currentScaleX, margin) {
      let firstDate = this.$refs.CesiumContainer.viewer.clock.startTime
      let currentDate = this.$refs.CesiumContainer.viewer.clock.currentTime

      d3.select(cursorId).attr(
        'x',
        currentScaleX(
          this.computeDateFromDuration(
            Cesium.JulianDate.secondsDifference(currentDate, firstDate)
          )
        ) - margin
      )
      d3.select(pointCursorId).attr(
        'x',
        currentScaleX(
          this.computeDateFromDuration(
            Cesium.JulianDate.secondsDifference(currentDate, firstDate)
          )
        ) - margin
      )
    },

    drawSpacecraftTimeline() {
      this.drawSpacecraftTimelineFromGround()
      this.drawSpacecraftTimelineFromPayload()
      this.drawSpacecraftTimelinePointOfInterestFromPayload()
      if (this.currentResultsLog.results.telecomChoice != 'NONE') {
        this.drawDataGraph()
      }
    },

    drawSpacecraftTimelinePointOfInterestFromPayload() {
      let payloadIntervals = []
      let isolatedPointsOfInterestLabels = []

      if (
        this.currentResultsLog?.results?.constellationsVisibilityData != null
      ) {
        let constellation = this.currentSpacecraftPOVTimelineConstellationsLabel
        let plane = this.currentSpacecraftPOVTimelineConstellationPlaneLabel
        let spacecraftIndex =
          this.currentSpacecraftPOVTimelineSpacecraftIndexLabel
        let spacecraftLabel =
          constellation +
          this.ID_SEPARATOR +
          plane +
          this.ID_SEPARATOR +
          spacecraftIndex

        let constellationData =
          this.currentResultsLog.results.constellationsVisibilityData[
            constellation
          ]

        let keysPointOfInterest = Object.keys(
          constellationData.spacecraftVisibilityIntervals[spacecraftLabel]
            .aoipayloadVisibilityIntervals
        )
        keysPointOfInterest.forEach((keyPointOfInterest) => {
          isolatedPointsOfInterestLabels.push(keyPointOfInterest)
          payloadIntervals.push(
            constellationData.spacecraftVisibilityIntervals[spacecraftLabel]
              .aoipayloadVisibilityIntervals[keyPointOfInterest]
          )
        })
      }
      isolatedPointsOfInterestLabels = this.croppedLabels(
        isolatedPointsOfInterestLabels
      )

      var orderedIsolatedPointsOfInterestVisibilityData =
        this.cropLabelsAndOrderDataAlphabetically(
          isolatedPointsOfInterestLabels,
          payloadIntervals
        )
      isolatedPointsOfInterestLabels = Object.keys(
        orderedIsolatedPointsOfInterestVisibilityData
      )
      payloadIntervals = Object.values(
        orderedIsolatedPointsOfInterestVisibilityData
      )

      this.cleanPointOfInterestTimelineView()

      const self = this
      const offset = 10

      const margin = { top: 10, right: 10, bottom: 40, left: 80 }
      if (document.getElementById('pointOfInterestTimeline') == null) {
        return
      }
      const svgWidth = document.getElementById(
        'pointOfInterestTimeline'
      ).offsetWidth

      let chartHeight = payloadIntervals.length * 30
      const svgHeight = chartHeight + margin.top + margin.bottom
      let chartWidth = svgWidth - margin.left - margin.right
      let zoom = d3
        .zoom()
        .scaleExtent([0.5, 20]) // This control how much you can unzoom (x0.5) and zoom (x20)
        .extent([
          [0, 0],
          [chartWidth, chartHeight]
        ])
        .on('zoom', updateChart)

      let svg = d3
        .select('#pointOfInterestTimeline')
        .append('svg')
        .attr('width', svgWidth)
        .attr('height', svgHeight)
        .call(zoom)
        .append('g')
        .attr('transform', `translate( ${margin.left}, ${margin.top})`)

      svg
        .append('defs')
        .append('SVG:clipPath')
        .attr('id', 'clipPOIfromPayload')
        .append('SVG:rect')
        .attr('width', chartWidth)
        .attr('height', chartHeight)
        .attr('x', 0)
        .attr('y', 0)

      let chart = svg.append('g').attr('clip-path', 'url(#clipPOIfromPayload)')

      let scaleX = d3
        .scaleUtc()
        .range([0, chartWidth])
        .domain([this.startOfSimulationDate, this.endOfSimulationDate])

      this.scaleXPoIFromSpacecraft = scaleX

      let xAxis = svg
        .append('g')

        .attr('transform', `translate(0, ${chartHeight + offset})`)
        .call(d3.axisBottom(scaleX))

      let y = d3
        .scaleBand()
        .domain(isolatedPointsOfInterestLabels)
        .range([0, chartHeight])
        .padding(0.1)

      svg
        .append('g')
        .attr('transform', `translate(0, ${offset})`)
        .call(d3.axisLeft(y))

      const div = d3
        .select('body')
        .append('div')
        .attr('class', 'tooltip')
        .style('opacity', 0)
        .style('z-index', 1000)
        .style('border-radius', '4px')
        .style('background-color', 'black')
        .style('font', '12px')
        .style('color', 'white')
        .style('padding', '5px')
        .style('position', 'absolute')

      let colorsArray = this.createColorsArray(
        isolatedPointsOfInterestLabels.length - 1
      )
      colorsArray = this.addBlackOrWhite(colorsArray)
      for (let i = 0; i < isolatedPointsOfInterestLabels.length; i++) {
        chart
          .selectAll('svg')
          .data(payloadIntervals[i])
          .enter()
          .append('rect')

          .attr('x', function (interval) {
            return scaleX(self.computeDateFromDuration(interval.start))
          })

          .attr('y', y(isolatedPointsOfInterestLabels[i]))
          .attr('width', (interval) => {
            let width =
              scaleX(this.computeDateFromDuration(interval.end)) -
              scaleX(this.computeDateFromDuration(interval.start))
            width = width > 0 ? width : 1

            return width
          })
          .attr('height', 20)
          .attr('transform', `translate(0, ${offset + 2})`)
          .style('fill', colorsArray[i])
          .attr('id', 'interval' + String(i))
          .on('mouseover', function (interval) {
            div.transition().duration(200).style('opacity', 0.9)
            div
              .html(
                'Length : ' +
                  self.convertToHourFormat(interval.end - interval.start) +
                  '<br>' +
                  'Start: ' +
                  self.computeUTCDateFromDuration(interval.start) +
                  '<br>' +
                  'End: ' +
                  self.computeUTCDateFromDuration(interval.end)
              )
              .style('left', d3.event.pageX + 'px')
              .style('top', d3.event.pageY + 'px')
          })
          .on('mouseout', function () {
            div.transition().duration(200).style('opacity', 0)
            div.html('')
          })

        chart
          .append('rect')
          .attr('y', y(isolatedPointsOfInterestLabels[i]))
          .attr('x', 0)
          .attr('width', chartWidth)
          .attr('height', 1)
          .attr('opacity', 0.1)
          .attr('transform', `translate(0, ${offset + 13})`)
          .attr('fill', this.$vuetify.theme.dark ? 'white' : '#121212')
      }

      chart
        .append('rect')
        .attr('id', 'timelineCursorPoIFromSpacecraft')
        .attr('x', 0)
        .attr('y', offset)
        .attr('width', 2)
        .attr('height', chartHeight)
        .style('fill', '#ff0102')

      chart
        .append('rect')
        .attr('id', 'timelinePointCursorPoIFromSpacecraft')
        .attr('x', 0)
        .attr('y', 0)
        .attr('width', 2)
        .attr('height', 5)
        .style('fill', '#ff0102')

      // A function that update the chart for given boundaries
      function updateChart() {
        // recover the new scale
        let newX = d3.event.transform.rescaleX(scaleX)
        self.scaleXPoIFromSpacecraft = newX

        // update axes with these new boundaries
        xAxis.call(d3.axisBottom(newX))
        for (let i = 0; i < payloadIntervals.length; i++) {
          chart
            .selectAll('#interval' + String(i))
            .data(payloadIntervals[i])
            .attr('x', function (interval) {
              return newX(self.computeDateFromDuration(interval.start))
            })
            .attr('width', (interval) => {
              let width =
                newX(self.computeDateFromDuration(interval.end)) -
                newX(self.computeDateFromDuration(interval.start))

              return width
            })
            .on('mouseover', function (interval) {
              div.transition().duration(200).style('opacity', 0.9)
              div
                .html(
                  'Length : ' +
                    self.convertToHourFormat(interval.end - interval.start) +
                    '<br>' +
                    'Start: ' +
                    self.computeUTCDateFromDuration(interval.start) +
                    '<br>' +
                    'End: ' +
                    self.computeUTCDateFromDuration(interval.end)
                )
                .style('left', d3.event.pageX + 'px')
                .style('top', d3.event.pageY + 'px')
            })
            .on('mouseout', function () {
              div.transition().duration(200).style('opacity', 0)
              div.html('')
            })
        }
      }
    },

    drawSpacecraftTimelineFromPayload() {
      let payloadIntervals = []

      let groundStationLabels = []

      if (
        this.currentResultsLog?.results?.constellationsVisibilityData != null
      ) {
        let constellation = this.currentSpacecraftPOVTimelineConstellationsLabel

        let plane = this.currentSpacecraftPOVTimelineConstellationPlaneLabel
        let spacecraftIndex =
          this.currentSpacecraftPOVTimelineSpacecraftIndexLabel
        let spacecraftLabel =
          constellation +
          this.ID_SEPARATOR +
          plane +
          this.ID_SEPARATOR +
          spacecraftIndex

        let constellationData =
          this.currentResultsLog.results.constellationsVisibilityData[
            constellation
          ]

        let keysGroundStation = Object.keys(
          constellationData.groundStationsVisibilityIntervals
        )
        keysGroundStation.forEach((keyGroundStation) => {
          groundStationLabels.push(
            constellationData.groundStationsVisibilityIntervals[
              keyGroundStation
            ].groundStationName
          )
          payloadIntervals.push(
            constellationData.spacecraftVisibilityIntervals[spacecraftLabel]
              .groundStationPayloadVisibilityIntervals[keyGroundStation]
          )
        })
      }

      var orderedGroundStationPayloadVisibilityData =
        this.cropLabelsAndOrderDataAlphabetically(
          groundStationLabels,
          payloadIntervals
        )
      groundStationLabels = Object.keys(
        orderedGroundStationPayloadVisibilityData
      )
      payloadIntervals = Object.values(
        orderedGroundStationPayloadVisibilityData
      )

      this.cleanSpacecraftPayloadTimelineView()

      const self = this
      const offset = 10

      const margin = { top: 10, right: 10, bottom: 40, left: 80 }
      if (document.getElementById('spacecraftPayloadTimeline') == null) {
        return
      }
      const svgWidth = document.getElementById(
        'spacecraftPayloadTimeline'
      ).offsetWidth

      let chartHeight = payloadIntervals.length * 30
      const svgHeight = chartHeight + margin.top + margin.bottom
      let chartWidth = svgWidth - margin.left - margin.right
      let zoom = d3
        .zoom()
        .scaleExtent([0.5, 20]) // This control how much you can unzoom (x0.5) and zoom (x20)
        .extent([
          [0, 0],
          [chartWidth, chartHeight]
        ])
        .on('zoom', updateChart)

      let svg = d3
        .select('#spacecraftPayloadTimeline')
        .append('svg')
        .attr('width', svgWidth)
        .attr('height', svgHeight)
        .call(zoom)
        .append('g')
        .attr('transform', `translate( ${margin.left}, ${margin.top})`)

      svg
        .append('defs')
        .append('SVG:clipPath')
        .attr('id', 'clipGroundStationFromPayload')
        .append('SVG:rect')
        .attr('width', chartWidth)
        .attr('height', chartHeight)
        .attr('x', 0)
        .attr('y', 0)

      let chart = svg
        .append('g')
        .attr('clip-path', 'url(#clipGroundStationFromPayload)')

      let scaleX = d3
        .scaleUtc()
        .range([0, chartWidth])
        .domain([this.startOfSimulationDate, this.endOfSimulationDate])

      this.scaleXGroundFromSpacecraft = scaleX

      let xAxis = svg
        .append('g')

        .attr('transform', `translate(0, ${chartHeight + offset})`)
        .call(d3.axisBottom(scaleX))

      let y = d3
        .scaleBand()
        .domain(groundStationLabels)
        .range([0, chartHeight])
        .padding(0.1)

      svg
        .append('g')
        .attr('transform', `translate(0, ${offset})`)
        .call(d3.axisLeft(y))

      const div = d3
        .select('body')
        .append('div')
        .attr('class', 'tooltip')
        .style('opacity', 0)
        .style('z-index', 1000)
        .style('border-radius', '4px')
        .style('background-color', 'black')
        .style('font', '12px')
        .style('color', 'white')
        .style('padding', '5px')
        .style('position', 'absolute')

      let colorsArray = this.createColorsArray(groundStationLabels.length - 1)
      colorsArray = this.addBlackOrWhite(colorsArray)

      for (let i = 0; i < groundStationLabels.length; i++) {
        chart
          .selectAll('svg')
          .data(payloadIntervals[i])
          .enter()
          .append('rect')

          .attr('x', function (interval) {
            return scaleX(self.computeDateFromDuration(interval.start))
          })

          .attr('y', y(groundStationLabels[i]))
          .attr('width', (interval) => {
            let width =
              scaleX(this.computeDateFromDuration(interval.end)) -
              scaleX(this.computeDateFromDuration(interval.start))
            width = width > 0 ? width : 1

            return width
          })
          .attr('height', 20)
          .attr('transform', `translate(0, ${offset + 2})`)
          .style('fill', colorsArray[i])
          .attr('id', 'interval' + String(i))
          .on('mouseover', function (interval) {
            div.transition().duration(200).style('opacity', 0.9)
            div
              .html(
                'Length : ' +
                  self.convertToHourFormat(interval.end - interval.start) +
                  '<br>' +
                  'Start: ' +
                  self.computeUTCDateFromDuration(interval.start) +
                  '<br>' +
                  'End: ' +
                  self.computeUTCDateFromDuration(interval.end)
              )
              .style('left', d3.event.pageX + 'px')
              .style('top', d3.event.pageY + 'px')
          })
          .on('mouseout', function () {
            div.transition().duration(200).style('opacity', 0)
            div.html('')
          })

        chart
          .append('rect')
          .attr('y', y(groundStationLabels[i]))
          .attr('x', 0)
          .attr('width', chartWidth)
          .attr('height', 1)
          .attr('opacity', 0.1)
          .attr('transform', `translate(0, ${offset + 13})`)
          .attr('fill', this.$vuetify.theme.dark ? 'white' : '#121212')
      }

      chart
        .append('rect')
        .attr('id', 'timelineCursorGroundFromSpacecraft')
        .attr('x', 0)
        .attr('y', offset)
        .attr('width', 2)
        .attr('height', chartHeight)
        .style('fill', '#ff0102')

      chart
        .append('rect')
        .attr('id', 'timelinePointCursorGroundFromSpacecraft')
        .attr('x', 0)
        .attr('y', 0)
        .attr('width', 2)
        .attr('height', 5)
        .style('fill', '#ff0102')

      // A function that update the chart for given boundaries
      function updateChart() {
        // recover the new scale
        let newX = d3.event.transform.rescaleX(scaleX)
        self.scaleXGroundFromSpacecraft = newX

        // update axes with these new boundaries
        xAxis.call(d3.axisBottom(newX))

        for (let i = 0; i < payloadIntervals.length; i++) {
          chart
            .selectAll('#interval' + String(i))
            .data(payloadIntervals[i])
            .attr('x', function (interval) {
              return newX(self.computeDateFromDuration(interval.start))
            })
            .attr('width', (interval) => {
              let width =
                newX(self.computeDateFromDuration(interval.end)) -
                newX(self.computeDateFromDuration(interval.start))

              return width
            })
            .on('mouseover', function (interval) {
              div.transition().duration(200).style('opacity', 0.9)
              div
                .html(
                  'Length : ' +
                    self.convertToHourFormat(interval.end - interval.start) +
                    '<br>' +
                    'Start: ' +
                    self.computeUTCDateFromDuration(interval.start) +
                    '<br>' +
                    'End: ' +
                    self.computeUTCDateFromDuration(interval.end)
                )
                .style('left', d3.event.pageX + 'px')
                .style('top', d3.event.pageY + 'px')
            })
            .on('mouseout', function () {
              div.transition().duration(200).style('opacity', 0)
              div.html('')
            })
        }
      }
    },

    drawSpacecraftTimelineFromGround() {
      let intervals = []

      let groundStationLabels = []

      if (
        this.currentResultsLog?.results?.constellationsVisibilityData != null
      ) {
        let constellation = this.currentSpacecraftPOVTimelineConstellationsLabel

        let plane = this.currentSpacecraftPOVTimelineConstellationPlaneLabel
        let spacecraftIndex =
          this.currentSpacecraftPOVTimelineSpacecraftIndexLabel
        let spacecraftLabel =
          constellation +
          this.ID_SEPARATOR +
          plane +
          this.ID_SEPARATOR +
          spacecraftIndex

        let constellationData =
          this.currentResultsLog.results.constellationsVisibilityData[
            constellation
          ]

        if (constellationData != null) {
          let keysGroundStation = Object.keys(
            constellationData.groundStationsVisibilityIntervals
          )
          keysGroundStation.forEach((keyGroundStation) => {
            let stationVisibilityTimeline =
              constellationData.groundStationsVisibilityIntervals[
                keyGroundStation
              ].stationVisibilityTimeline
            groundStationLabels.push(
              constellationData.groundStationsVisibilityIntervals[
                keyGroundStation
              ].groundStationName
            )
            intervals.push(stationVisibilityTimeline[spacecraftLabel])
          })
        }
      }

      var orderedGroundStationVisibilityData =
        this.cropLabelsAndOrderDataAlphabetically(
          groundStationLabels,
          intervals
        )
      groundStationLabels = Object.keys(orderedGroundStationVisibilityData)
      intervals = Object.values(orderedGroundStationVisibilityData)

      this.cleanSpacecraftTimelineView()

      const self = this
      const offset = 10

      const margin = { top: 10, right: 10, bottom: 40, left: 80 }
      if (document.getElementById('spacecraftTimeline') == null) {
        return
      }
      const svgWidth = document.getElementById('spacecraftTimeline').offsetWidth

      let chartHeight = intervals.length * 30
      const svgHeight = chartHeight + margin.top + margin.bottom
      let chartWidth = svgWidth - margin.left - margin.right
      let zoom = d3
        .zoom()

        .scaleExtent([0.5, 20]) // This control how much you can unzoom (x0.5) and zoom (x20)
        .extent([
          [0, 0],
          [chartWidth, chartHeight]
        ])
        .on('zoom', updateChart)

      let svg = d3
        .select('#spacecraftTimeline')
        .append('svg')
        .attr('width', svgWidth)
        .attr('height', svgHeight)
        .call(zoom)
        .append('g')
        .attr('transform', `translate( ${margin.left}, ${margin.top})`)

      // svg.append('rect')
      //   .attr('width', chartWidth)
      //   .attr('height', svgHeight)
      //   .style('fill', 'none')
      //   .style('pointer-events', 'all')

      //   .call(zoom)

      svg
        .append('defs')
        .append('SVG:clipPath')
        .attr('id', 'clipSpacecraftFromGroundStation')
        .append('SVG:rect')
        .attr('width', chartWidth)
        .attr('height', chartHeight)
        .attr('x', 0)
        .attr('y', 0)

      let chart = svg
        .append('g')
        .attr('clip-path', 'url(#clipSpacecraftFromGroundStation)')

      let scaleX = d3
        .scaleUtc()
        .range([0, chartWidth])
        .domain([this.startOfSimulationDate, this.endOfSimulationDate])

      this.scaleXSpacecraftFromGround = scaleX

      let xAxis = svg
        .append('g')

        .attr('transform', `translate(0, ${chartHeight + offset})`)
        .call(d3.axisBottom(scaleX))

      let y = d3
        .scaleBand()
        .domain(groundStationLabels.map((d) => d))
        .range([0, chartHeight])
        .padding(0.1)

      // yAxis
      svg
        .append('g')
        .attr('transform', `translate(0, ${offset})`)
        .call(d3.axisLeft(y))

      const div = d3
        .select('body')
        .append('div')
        .attr('class', 'tooltip')
        .style('opacity', 0)
        .style('z-index', 1000)
        .style('border-radius', '4px')
        .style('background-color', 'black')
        .style('font', '12px')
        .style('color', 'white')
        .style('padding', '5px')
        .style('position', 'absolute')
      let colorsArray = this.createColorsArray(intervals.length - 1)
      colorsArray = this.addBlackOrWhite(colorsArray)

      for (let i = 0; i < intervals.length; i++) {
        chart
          .selectAll('svg')
          .data(intervals[i])
          .enter()
          .append('rect')

          .attr('x', function (interval) {
            return scaleX(self.computeDateFromDuration(interval.start))
          })

          .attr('y', y(groundStationLabels[i]))
          .attr('width', (interval) => {
            let width =
              scaleX(this.computeDateFromDuration(interval.end)) -
              scaleX(this.computeDateFromDuration(interval.start))
            width = width > 0 ? width : 1

            return width
          })
          .attr('height', 20)
          .attr('transform', `translate(0, ${offset + 2})`)
          .style('fill', colorsArray[i])
          .attr('id', 'interval' + String(i))
          .on('mouseover', function (interval) {
            div.transition().duration(200).style('opacity', 0.9)
            div
              .html(
                'Length : ' +
                  self.convertToHourFormat(interval.end - interval.start) +
                  '<br>' +
                  'Start: ' +
                  self.computeUTCDateFromDuration(interval.start) +
                  '<br>' +
                  'End: ' +
                  self.computeUTCDateFromDuration(interval.end)
              )
              .style('left', d3.event.pageX + 'px')
              .style('top', d3.event.pageY + 'px')
          })
          .on('mouseout', function () {
            div.transition().duration(200).style('opacity', 0)
            div.html('')
          })
        chart
          .append('rect')
          .attr('y', y(groundStationLabels[i]))
          .attr('x', 0)
          .attr('width', chartWidth)
          .attr('height', 1)
          .attr('opacity', 0.1)
          .attr('transform', `translate(0, ${offset + 13})`)
          .attr('fill', this.$vuetify.theme.dark ? 'white' : '#121212')
      }

      chart
        .append('rect')
        .attr('id', 'timelineCursorSpacecraftFromGround')
        .attr('x', 0)
        .attr('y', offset)
        .attr('width', 2)
        .attr('height', chartHeight)
        .style('fill', '#ff0102')

      chart
        .append('rect')
        .attr('id', 'timelinePointCursorSpacecraftFromGround')
        .attr('x', 0)
        .attr('y', 0)
        .attr('width', 2)
        .attr('height', 5)
        .style('fill', '#ff0102')

      // A function that update the chart for given boundaries
      function updateChart() {
        // recover the new scale
        let newX = d3.event.transform.rescaleX(scaleX)
        self.scaleXSpacecraftFromGround = newX

        // update axes with these new boundaries
        xAxis.call(d3.axisBottom(newX))

        for (let i = 0; i < intervals.length; i++) {
          chart
            .selectAll('#interval' + String(i))
            .data(intervals[i])
            .attr('x', function (interval) {
              return newX(self.computeDateFromDuration(interval.start))
            })
            .attr('width', (interval) => {
              let width =
                newX(self.computeDateFromDuration(interval.end)) -
                newX(self.computeDateFromDuration(interval.start))

              return width
            })
            .on('mouseover', function (interval) {
              div.transition().duration(200).style('opacity', 0.9)
              div
                .html(
                  'Length : ' +
                    self.convertToHourFormat(interval.end - interval.start) +
                    '<br>' +
                    'Start: ' +
                    self.computeUTCDateFromDuration(interval.start) +
                    '<br>' +
                    'End: ' +
                    self.computeUTCDateFromDuration(interval.end)
                )
                .style('left', d3.event.pageX + 'px')
                .style('top', d3.event.pageY + 'px')
            })
            .on('mouseout', function () {
              div.transition().duration(200).style('opacity', 0)
              div.html('')
            })
        }
      }
    },

    /// /////

    drawGroundStationTimeline() {
      this.currentTimelineLabel =
        this.currentConstellationLabel +
        ' - ' +
        this.currentPlaneLabel +
        ' - ' +
        this.currentInPlaneSpacecraftIndexLabel
      const intervals = this.timelineIntervals[this.currentTimelineLabel]
      this.cleanGroundStationTimelineView()

      const self = this
      const offset = 10

      const margin = 10

      const svgWidth = document.getElementById(
        'groundStationTimeline'
      ).offsetWidth
      const svgHeight = 100
      let chartWidth = svgWidth - 2 * margin
      let chartHeight = 40

      let zoom = d3
        .zoom()
        .scaleExtent([0.5, 20]) // This control how much you can unzoom (x0.5) and zoom (x20)
        .extent([
          [0, 0],
          [svgWidth, svgHeight]
        ])
        .on('zoom', updateChart)
      let svg = d3
        .select('#groundStationTimeline')
        .append('svg')
        .attr('width', svgWidth)
        .attr('height', svgHeight)
        .call(zoom)

      let chart = svg.append('g').attr('transform', `translate(${margin}, 0)`)

      let scaleX = d3
        .scaleUtc()
        .domain([this.startOfSimulationDate, this.endOfSimulationDate])
        .range([0, chartWidth])

      this.scaleX = scaleX

      let xAxis = svg
        .append('g')

        .attr('transform', `translate(0, ${chartHeight + offset})`)
        .call(d3.axisBottom(scaleX))

      const div = d3
        .select('body')
        .append('div')
        .attr('class', 'tooltip')
        .style('opacity', 0)
        .style('z-index', 1000)
        .style('border-radius', '4px')
        .style('background-color', 'black')
        .style('font', '12px')
        .style('color', 'white')
        .style('padding', '5px')
        .style('position', 'absolute')

      chart
        .selectAll('rect')
        .data(intervals)
        .enter()
        .append('rect')
        .attr('x', function (interval) {
          return scaleX(self.computeDateFromDuration(interval.start)) - margin
        })

        .attr('y', offset)
        .attr('width', (interval) => {
          let width =
            scaleX(this.computeDateFromDuration(interval.end)) -
            scaleX(this.computeDateFromDuration(interval.start))
          width = width > 0 ? width : 1

          return width
        })
        .attr('height', chartHeight)
        .style('fill', this.$vuetify.theme.dark ? '#2e1f9a' : '#1b125a')
        .on('mouseover', function (interval) {
          div.transition().duration(200).style('opacity', 0.8)
          div
            .html(
              'Duration : ' +
                self.convertToHourFormat(interval.end - interval.start) +
                '<br>' +
                'Start: ' +
                self.computeUTCDateFromDuration(interval.start) +
                '<br>' +
                'End: ' +
                self.computeUTCDateFromDuration(interval.end)
            )
            .style('left', d3.event.pageX + 'px')
            .style('top', d3.event.pageY + 'px')
        })
        .on('mouseout', function (interval) {
          div.transition().duration(200).style('opacity', 0)
          div.html('')
        })
      chart
        .append('rect')
        .attr('id', 'timelineCursor')
        .attr('x', 0)
        .attr('y', offset)
        .attr('width', 2)
        .attr('height', chartHeight)
        .style('fill', '#ff0102')

      chart
        .append('rect')
        .attr('id', 'timelinePointCursor')
        .attr('x', 0)
        .attr('y', 0)
        .attr('width', 2)
        .attr('height', 5)
        .style('fill', '#ff0102')

      // now the user
      // A function that update the chart for given boundaries
      function updateChart() {
        // recover the new scale
        let newX = d3.event.transform.rescaleX(scaleX)
        self.scaleX = newX

        // update axes with these new boundaries
        xAxis.call(d3.axisBottom(newX))

        chart
          .selectAll('rect')
          .data(intervals)
          .attr('x', function (interval) {
            return newX(self.computeDateFromDuration(interval.start)) - margin
          })
          .attr('width', (interval) => {
            let width =
              newX(self.computeDateFromDuration(interval.end)) -
              newX(self.computeDateFromDuration(interval.start))
            width = width > 0 ? width : 1

            return width
          })
          .on('mouseover', function (interval) {
            div.transition().style('opacity', 0.8)
            div
              .html(
                'Duration : ' +
                  self.convertToHourFormat(interval.end - interval.start) +
                  '<br>' +
                  'Start: ' +
                  self.computeUTCDateFromDuration(interval.start) +
                  '<br>' +
                  'End: ' +
                  self.computeUTCDateFromDuration(interval.end)
              )
              .style('left', d3.event.pageX + 'px')
              .style('top', d3.event.pageY + 'px')
          })
          .on('mouseout', function (interval) {
            div.transition().duration(200).style('opacity', 0)
            div.html('')
          })
      }
    }
  }
}
</script>

<style scoped>
.cesium-card {
  height: 30vw;
}
.viewer {
  width: 100%;
  z-index: 1;
  position: relative;
}

.cesiumColorScale {
  position: absolute;
  left: 1%;
  top: 1%;
  z-index: 2;
  color: #fff;
}

.bug-button {
  background: #ff5252 !important;
}
</style>
